export default {
  a4_paper: "kertas A4",
  abandoned: "Ditinggalkan",
  accepting_payment: "Menerima pembayaran",
  accepting_payment_desc: "Matikan ini jika Anda ingin berhenti menerima pembayaran tetapi tetap menampilkan halaman Anda.",
  action: "Tindakan",
  actions: "Tindakan",
  activate: "Aktifkan",
  activate_member: "Aktifkan anggota",
  active_addons: "Add-ons aktif",
  add: "Tambah",
  add_address: "Tambah alamat",
  add_another: "Tambah yang lain",
  add_assignees: "Tambahkan Penerima Tugas",
  add_bank: "Tambah bank",
  add_card: "Tambahkan Kartu",
  add_category: "Tambah kategori",
  add_discount: "Tambah diskon",
  add_donation_amount: "Tambahkan jumlah donasi",
  add_extra_info: "Tambah Info",
  add_filter: "Tambahkan filter",
  add_images: "Tambahkan gambar",
  add_member: "Tambah member",
  add_new: "Tambah baru",
  add_new_assignees: "Tambahkan penerima tugas baru",
  add_new_cashier: "Tambah kasir baru",
  add_new_user: "Tambahkan pengguna baru",
  add_payment_method: "Tambahkan metode pembayaran",
  add_people: "Tambahkan orang",
  add_photo: "Tambah foto",
  add_product: "Tambah produk",
  add_slot: "Tambahkan slot",
  add_source: "Tambah source",
  add_to_segment: "Tambahkan ke Segmen",
  add_tracking_info: "Tambah info pelacakan",
  add_variant: "Tambah varian",
  added: "Ditambahkan",
  addon: "Add-on",
  addons: "Add-on",
  address: "alamat",
  advance_shipping_setting: "Kelola Fitur Lanjutan Pengiriman",
  advanced_setup: "Konfigurasi lanjutan",
  after_num_days: "Setele {num} hari",
  agent: "Ejen",
  all: "Semua",
  allow_multiple_selection: "Izinkan beberapa pilihan",
  always: "Selalu",
  amount: "Jumlah",
  amount_needed: "Jumlah diperlukan",
  amount_paid: "Jumlah dibayar",
  analytics: "Analitik",
  analytics_description: "Lacak kinerja pemasaran Anda",
  announcement: "Pengumuman",
  apply: "Terap",
  appointments: "Temu Janji",
  are_you_sure_to_proceed: "Apakah Anda yakin ingin melanjutkan?",
  arrange_shipment: "Atur pengiriman",
  arranged: "Sudah diatur",
  assign: "Tetapkan",
  assign_table: "Tetapkan tabel",
  assign_table_description: "Kelola tabel di outlet",
  assignee_and_customer: "Penerima & pelanggan",
  assignees: "Penerima tugas",
  attach_invoices: "Lampirkan Invois",
  attach_member: "Tetapkan member",
  attach_members: "Tetapkan member",
  attach_products: "Lampirkan produk",
  average_transaction: "Transaksi rata-rata",
  back: "Kembali",
  back_to_customers_page: "Kembali ke halaman pelanggan",
  back_to_tasks: "Kembali ke Tugas",
  back_to_upload_page: "Kembali ke halaman unggah",
  background_color: "Warna Background",
  balance_amount: "Jumlah baki",
  balance_due: "Jumlah harus dibayar",
  bank: "Bank",
  bank_account: "Akun Bank",
  bank_account_number: "Nomor akun bank",
  bank_account_owner: "Pemilik akun bank",
  batch_edit: "Edit Semua",
  batch_edit_details: "Edit Detail",
  bill_to: "Tagih kepada",
  bills: "Tagihan",
  blast_sms: "SMS ledakan",
  books: "Books",
  browse: "Jelajahi",
  bundle: "Bundle",
  bundle_not_found: "Bundle tidak dijumpai",
  business_hours: "Jam kerja",
  campaign: "Kampanye",
  campaign_description: "Deskripsi kampanye",
  campaign_details: "Detail kampanye",
  campaign_details_desc: "Tetapkan judul, deskripsi, dan sasaran kampanye Anda.",
  campaign_end_date: "Tanggal akhir kampanye (opsional)",
  campaign_end_date_desc: "Tambahkan sasaran dan bilah kemajuan ke halaman Anda",
  campaign_title: "Judul kampanye",
  cancel: "Batal",
  card: "Kartu",
  card_list: "Daftar Kartu",
  cash_on_delivery: "Bayar di tempat",
  categories: "Kategori",
  category: "kategori",
  category_image: "Gambar kategori",
  change: "ubah",
  change_image: "Ubah foto",
  change_phone_number_team_member: "Ubah nomor telepon anggota tim Anda",
  change_photo: "Ubah Foto",
  change_video: "Tukar video",
  changes_not_saved: "Perubahan tidak disimpan",
  charge: "Caj",
  checkout: "Checkout",
  checkout_form: "Form Check Out",
  choose_courier: "Pilih Kurier",
  choose_customers: "Pilih pelanggan",
  choose_gender: "Pilih jenis kelamin",
  choose_layout: "Pilih Layout",
  choose_new_assignee_for_task: "Pilih penerima tugas baru untuk tugas ini",
  choose_segment_add_customers: "Pilih segmen yang ingin Anda tambahkan pelanggannya",
  choose_segment_that_you_want_filter: "Pilih segmen yang ingin Anda filter",
  choose_your_assigness: "Pilih penerima tugas",
  classic: "Classic",
  clear: "Jelas",
  clear_all_filters: "Hapus semua filter",
  clear_filters: "Hapus filter",
  clear_selection: "Hapus pilihan",
  click_confirm_to_proceed: "Klik 'Konfirmasi' untuk melanjutkan.",
  clicks: "Klik",
  close: "Tutup",
  closed: "Tutup",
  collect: "Kumpul",
  collect_extra_info: "Info tambahan",
  commission: "Komisi",
  commission_list: "Daftar Komisi",
  commissions: "Komisi",
  company: "Perusahaan",
  company_details: "Perusahaan Detail",
  company_logo: "Logo perusahaan",
  completed: "Selesai",
  confirm: "Konfirmasi",
  confirmation_code: "Kode konfirmasi",
  connect: "Connect",
  connect_website: "Hubung website",
  contact: "Hubungi",
  continue: "Lanjutkan",
  copy: "Salin",
  copy_custom_link: "Salin link khusus",
  copy_link: "Salin link",
  copy_paste_content: "Salin & tempel konten berikut ke situs web Anda",
  copy_short_link: "Salin link pendek",
  copy_url: "Salin URL",
  coupon: "Kupon",
  coupon_code: "Kode kupon",
  coupons: "Kupon",
  courier: "Kurir",
  cover_photo: "Foto sampul",
  cover_photo_desc: "Tambahkan foto atau video ke halaman donasi Anda",
  create: "Buat",
  create_account: "Buat akun",
  create_form: "Buat Form Baru",
  create_new_category: "Buat Kategori Baru",
  create_new_task: "Buat tugas baru",
  create_product_notes: "Buat nota produk",
  create_segment: "Buat segmen",
  create_task: "Buat tugas",
  created: "Dibuat",
  created_on: "Dibuat pada",
  credit_history: "Sejarah Kredit",
  custom: "Khusu",
  custom_dates: "Tanggal khusus",
  custom_link: "Link khusus",
  customer: "Pelanggan",
  customer_actions: "Tindakan pelanggan",
  customer_info: "Info pelanggan",
  customer_message: "Pesan Pelanggan",
  customer_name: "Nama Pelanggan",
  customer_selection: "Pilihan pelanggan",
  customers: "Pelanggan",
  customers_engaged: "Pelanggan terlibat",
  customers_note: "Pesan pelanggan",
  customers_selected_from_list: "pelanggan dipilih dari daftar pelanggan",
  customize_column: "Sesuaikan Kolom",
  customize_message: "Ubah pesan",
  data_collection: "Tambahkan data",
  database: "Basis Data",
  date: "Tanggal",
  date_range: "Range tanggal",
  date_selection: "Pemilihan tanggal",
  date_selection_mode: "Mode Pemilihan Tanggal",
  day: "Hari",
  default_payment_frequency: "Frekuensi pembayaran default",
  default_tax_rate: "Tarif pajak default",
  delete: "Hapus",
  delete_category: "Hapus kategori",
  delete_customer: "Hapus pelanggan",
  delete_form: "Hapus Form",
  delete_form_confirmation: "Anda yakin ingin menghapus form ini? form ini akan dihapus secara permanen.",
  delete_image: "Hapus foto",
  delete_image_confirmation: "Anda yakin ingin menghapus foto ini? Foto ini akan dihapus secara permanen.",
  delete_item: "Hapus item",
  delete_member: "Hapus member",
  delete_page: "Hapus halaman",
  delete_product: "Hapus Produk",
  delete_product_confirmation: "Anda yakin ingin menghapus produk ini? produk ini akan dihapus secara permanen.",
  delete_segment: "Hapus segmen",
  delete_segment_confirmation: "Apakah Anda yakin ingin menghapus segmen ini?",
  delete_selected: "Hapus yang dipilih",
  delete_task: "Hapus tugas",
  delete_task_confirmation_1: "Anda yakin ingin menghapus tugas ini?",
  delete_task_confirmation_2: "Tugas ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini.",
  delivered: "selesai dikirim",
  delivery_charge: "Tarif pengiriman",
  delivery_day: "Hari Pengiriman",
  delivery_platform: "Platform Pengiriman",
  description: "Deskripsi",
  description_optional: "Deskripsi (Opsional)",
  details: "Rincian",
  dialog_please_pay: "Bayar untuk teruskan",
  dialog_please_pay_text: "Anda akan diarahkan ke halaman pembayaran setelah mengklik tombol 'Bayar Sekarang'. Harap tutup halaman tersebut setelah pembayaran selesai.",
  difficult_to_learn: "Sulit dipelajari.",
  disable_checkout: "Nonaktifkan checkout",
  disable_payment: "Nonaktifkan pembayaran",
  disabled: "Nonaktif",
  discard_changes: "Membuang perubahan",
  discount: "Diskon",
  domain_verifications: "Verifikasi Domain",
  donation_amounts: "Jumlah donasi",
  donation_amounts_desc: "Tetapkan jumlah donasi pada kampanye Anda.",
  donation_forms: "form Donasi",
  donation_product_limit_reached: "Batas tercapai. Anda hanya dapat menambahkan hingga 7 jumlah khusus yang berbeda.",
  done: "Selesai",
  donor: "donor",
  donors: "Donor",
  download: "Unduh",
  download_as_pdf: "Unduh sebagai PDF",
  download_as_png: "Unduh sebagai PNG",
  drop_off: "Drop-off",
  due_by: "Batas oleh",
  due_date: "Batas waktu",
  duplicate: "Duplicate",
  duplicate_form: "Salin form",
  duplicate_product: "Salin produk",
  edit: "Edit",
  edit_address: "Edit Alamat",
  edit_category: "Edit Kategori",
  edit_customer_info: "Edit Info Pelanggan",
  edit_details: "Sunting Detil",
  edit_extra_info: "Ubah Info Tambahan",
  edit_member: "Edit member",
  edit_message_template: "Edit Template pesanan",
  edit_new_cashier: "Edit kasir baru",
  edit_order: "Edit pesanan",
  edit_subscription: "Sunting Langganan",
  edit_variant: "Edit varian",
  edit_weight: "Edit berat",
  email: "Email",
  email_address: "Alamat Email",
  embed: "Sematkan",
  embed_as: "Sematkan sebagai",
  embed_form: "Sematkan form",
  embed_in_website: "Sematkan di website",
  embed_video: "Sematkan video",
  enable_business_hour: "Aktifkan jam kerja",
  engaged_customers: "Pelanggan yang terlibat",
  engagement_rate: "Rasio engagemente",
  enter_email_new_member: "Masukkan email anggota tim baru",
  enter_individual_value: "Masukkan Nilai Komisi",
  enter_segment_name_and_description: "Masukkan nama dan deskripsi segmen Anda di bawah.",
  enter_value: "Masukkan nilai",
  error: "Error",
  error_message: {
    add_product_before_addons: "Harap tambahkan produk terlebih dahulu sebelum mengelola add-on",
    add_product_before_image: "Silakan tambahkan produk terlebih dahulu sebelum menambahkan lebih banyak gambar",
    amount_is_required: "Jumlah yang diperlukan",
    category_is_required: "Kategori wajib diisi",
    check_email_logging_number: "Periksa email kamu atau coba masuk dengan nomor kamu",
    check_number_logging_email: "Periksa nomor kamu atau coba masuk dengan email kamu",
    checkout_payment_field_required: "Kolom Checkout / Pembayaran wajib diisi",
    copy_address_failed: "Gagal menyalin alamat. Silakan coba lagi",
    date_is_required: "Tanggal wajib diisi",
    delete_product_remove_variants: "Hapus produk untuk menghapus semua varian",
    discount_price_not_bigger: "Harga diskon tidak boleh lebih besar dari harga produk",
    enter_email_first: "Masukkan alamat email terlebih dahulu",
    enter_new_email: "Masukkan alamat email baru terlebih dahulu",
    enter_new_phone: "Masukkan nomor telepon baru terlebih dahulu",
    enter_phone_number: "Masukkan nomor telepon terlebih dahulu",
    error_adding_card: "Kesalahan saat menambahkan kartu. Silakan hubungi penyedia kartu debit/kredit kamu untuk bantuan lebih lanjut. Atau coba gunakan kartu lain",
    error_occured: "Terjadi kesalahan. Silakan coba lagi nanti.",
    exceeded_form_count: "Melebihi total jumlah form yang diizinkan",
    exceeded_member_count: "Melebihi total jumlah anggota yang diizinkan",
    form_name_required: "Nama form wajib diisi",
    image_file_is_required: "File gambar diperlukan",
    image_invalid: "Gambar ini tidak valid",
    invalid_amount: "Jumlah tidak valid",
    invalid_code: "Kode salah. Silakan coba lagi.",
    invalid_confirmation_code: "Kode konfirmasi tidak valid",
    invalid_email_or_password: "Email atau kata sandi tidak valid",
    invalid_email_phone_password: "Email/telepon atau kata sandi tidak valid",
    invalid_plan: "Paket tidak valid",
    invalid_postcode_number: "Nomor kode pos tidak valid",
    invalid_tac: "TAC tidak valid. Silakan coba lagi.",
    invalid_tac_number: "Nomor TAC tidak valid",
    invoice_is_required: "Faktur diperlukan",
    item_is_required: "Barang diperlukan",
    max_hundred_orders: "Maksimum 100 pesanan dalam satu tindakan",
    max_images_ten: "Jumlah maksimum gambar adalah 10 per upload",
    max_orders_in_export: "Maksimum {count} pesanan dalam satu ekspor",
    no_account_associated_email: "Tidak ada akun pengguna yang terkait dengan email yang diberikan",
    no_account_associated_phone: "Tidak ada akun pengguna yang terkait dengan telepon yang diberikan",
    no_account_email_address: "Tidak ada akun yang ditemukan untuk alamat email yang dimasukkan",
    no_account_found_phone_number: "Tidak ada akun yang ditemukan untuk nomor telepon yang dimasukkan",
    no_account_phone_number: "Tidak ada akun untuk nomor telepon yang diberikan",
    no_image_found: "Tidak ada gambar yang ditemukan.",
    no_options_selected: "Tidak ada opsi yang dipilih",
    no_order_export: "Tidak ada pesanan untuk diekspor",
    no_product_selected: "Tidak ada produk yang dipilih",
    no_shipping_method: "Tidak ada metode pengiriman yang dipilih",
    no_user_google_id: "Tidak ada pengguna untuk ID Google yang diberikan. Silakan lanjutkan untuk mendaftar.",
    not_enough_stock: "Stok yang tersedia tidak cukup. Ubah jumlah pesanan kamu atau konsultasikan dengan penjual.",
    page_content_not_empty: "Konten halaman tidak boleh kosong",
    parcel_label_not_available: "Label paket belum tersedia",
    password_not_match: "Kata sandi tidak cocok",
    payment_method_required: "Metode pembayaran diperlukan",
    please_add_product_first: "Silakan tambahkan produk terlebih dahulu sebelum menambahkan lebih banyak gambar",
    please_choose_courier: "Silahkan pilih kurir",
    please_enable_at_setup: "Harap aktifkan ini terlebih dahulu di Pengaturan -> Pengiriman",
    please_enter_max_weight: "Harap masukkan berat maksimum dengan benar",
    please_enter_valid_domain: "Harap masukkan nama domain yang valid.",
    please_fill_all_items: "Silahkan isi semua item",
    please_fill_company_address: "Silakan isi alamat perusahaan di halaman Pengaturan terlebih dahulu",
    please_fill_email_phone: "Silakan isi email atau nomor telepon kamu",
    please_fill_out_all: "Harap isi semua kolom",
    please_fill_out_all_required: "Please fill out all required fields",
    please_publish_this_form: "Harap publikasikan form ini sebelum membagikannya.",
    please_select_courier: "Silakan pilih satu atau lebih kurir",
    please_select_payment_method: "Silakan pilih metode pembayaran",
    please_select_required_column: "Silakan pilih kolom yang diperlukan",
    please_setup_bundle_items: "Silakan atur item Bundle kamu",
    please_setup_your_variant: "Silakan atur varian kamu terlebih dahulu",
    reminder_channel_required: "Saluran pengingat diperlukan",
    segment_update_unsuccessful: "Pembaruan segmen gagal",
    select_one_order: "Pilih setidaknya 1 pesanan untuk melanjutkan",
    select_one_order_export: "Pilih setidaknya 1 pesanan untuk diekspor",
    select_one_order_ship: "Pilih minimal 1 pesanan untuk dikirim",
    select_only_overdue: "Pilih saja Terlambat atau Belum Terkirim.",
    seller_required: "Penjual diperlukan",
    sorry_company_subsidised: "Maaf, kamu sudah memiliki perusahaan lain yang disubsidi",
    sorry_no_open_seats: "Maaf, tidak ada lagi kursi terbuka untuk program ini",
    sorry_not_eligible: "Maaf, kamu tidak memenuhi syarat untuk program ini",
    sorry_this_offer_ended: "Maaf, penawaran ini sudah berakhir",
    this_email_must_verified: "Alamat email ini harus diverifikasi agar dapat digunakan untuk masuk. Harap masuk dengan nomor telepon.",
    this_method_not_supported: "Metode ini tidak didukung",
    unable_to_add_customer_segment: "Tidak dapat menambahkan pelanggan ke segmen",
    unable_to_add_new_assignee: "Tidak dapat menambahkan penerima tugas baru",
    unable_to_change_segment_description: "Tidak dapat mengubah deskripsi segmen",
    unable_to_change_segment_title: "Tidak dapat mengubah judul segmen.",
    unable_to_change_task_name: "Tidak dapat mengubah nama tugas",
    unable_to_complete_request: "Tidak dapat menyelesaikan permintaan kamu. Silakan coba lagi nanti",
    unable_to_load_data: "Tidak dapat memuat data",
    please_try_again: "Silakan coba lagi",
    unable_to_complete_request_contact: "Tidak dapat menyelesaikan permintaan kamu. Silakan hubungi tim dukungan kami.",
    unable_to_make_payment: "Tidak dapat melakukan pembayaran. Coba lagi nanti",
    unable_to_create_segment: "Tidak dapat membuat segmen",
    unable_to_create_task: "Tidak dapat membuat tugas",
    unable_to_delete_customer: "Tidak dapat menghapus pelanggan",
    unable_to_import_csv: "Tidak dapat mengimpor CSV",
    unable_to_match_data: "Tidak dapat mencocokkan data kamu. Silakan coba lagi nanti",
    unable_to_remove_assignee: "Tidak dapat menghapus penerima tugas",
    unable_to_remove_card: "Tidak dapat mengeluarkan kartu. Kartu saat ini mungkin terkait dengan langganan aktif.",
    unable_to_remove_customer: "Tidak dapat menghapus pelanggan",
    unable_to_remove_segment: "Tidak dapat menghapus segmen",
    unable_to_remove_task: "Tidak dapat menghapus tugas",
    unable_to_resume_update: "Tidak dapat melanjutkan pembaruan. Silakan hubungi dukungan.",
    unable_to_send_confirmation: "Tidak dapat mengirim kode konfirmasi, periksa alamat email yang benar",
    unable_to_send_tac: "Tidak dapat mengirim TAC, periksa nomor telepon yang benar",
    unable_to_stop_update: "Tidak dapat menghentikan pembaruan. Silakan hubungi dukungan.",
    unable_to_submit_order: "Tidak dapat mengirimkan pesanan kamu. Silakan coba lagi nanti",
    unable_to_subscribe_card: "Tidak dapat berlangganan. Silakan coba kartu lain atau hubungi tim dukungan kami.",
    unable_to_subscribe_method: "Tidak dapat berlangganan. Silakan coba metode lain atau hubungi tim dukungan kami.",
    unable_to_subscribe_try_again_contact_us: "Tidak dapat berlangganan. Silakan coba lagi atau hubungi tim dukungan kami.",
    unable_to_update_custom_link: "Tidak dapat memperbarui tautan khusus. Silakan coba nama lain atau hubungi dukungan kami",
    unable_to_update_order: "Tidak dapat memperbarui setelan pesanan. Silakan coba lagi nanti",
    unable_to_update_products: "Tidak dapat memperbarui produk. Silakan hubungi dukungan.",
    unable_to_update_template: "Tidak dapat memperbarui template",
    unable_to_upgrade: "Tidak dapat meningkatkan versi. Silakan hubungi tim dukungan kami.",
    unable_to_upload_document: "Tidak dapat mengunggah dokumen kamu. Silakan coba lagi nanti",
    unable_to_upload_image: "Tidak dapat mengunggah gambar. Silakan coba lagi nanti",
    url_invalid: "URL ini tidak valid",
    user_accepted_invitation: "Pengguna ini sudah menerima undangan kamu",
    error_move_item: "Error moving {item}",
    call_patient_in_first: "Please call the in the patient first",
    file_reached_limit: "File reached limit",
    create_item_first: "Please create {item} first",
  },
  error_unable_to_subscribe: "Tidak dapat berlangganan. Silakan coba kartu lain atau hubungi tim dukungan kami.",
  error_unable_to_upgrade: "Tidak dapat meningkatkan versi. Silakan hubungi tim dukungan kami.",
  estimated_price: "Perkiraan harga",
  event_id: "ID acara",
  every_record_with_error: "Setiap catatan dengan kesalahan tidak akan disertakan dalam segmen Anda.",
  example: "Contoh",
  exit: "keluar",
  expected: "Harapkan",
  expense: "Pengeluaran",
  expiry: "Kadaluwarsa",
  export: "Export",
  extra_info: "Info tambahan",
  fees_and_tips: "Biaya & tip",
  fees_and_tips_desc: "Konfigurasikan biaya & kiat pada kampanye Anda",
  fill_all_field_below: "Isi semua kolom di bawah",
  filter: "Filter",
  filter_age: "Filter Usia",
  filter_age_with_value: "Filter usia dengan nilai",
  filter_applied: "Filter diterapkan",
  filter_chart: "Setup Filter",
  filter_customer_that_are_created: "Filter pelanggan yang dibuat",
  filter_customer_with_gender: "Filter pelanggan dengan jenis kelamin",
  filter_data_created_on: "Filter tanggal (dibuat pada)",
  filter_gender: "Filter jenis kelamin",
  filter_order_count: "Filter jumlah pesanan",
  filter_order_count_with_value: "Filter jumlah pesanan dengan nilai",
  filter_segment: "Filter segmen",
  filter_total_contribution: "Filter jumlah donasi",
  filters: "Setup Filter",
  finish: "Selesai",
  finish_up_segment: "Selesaikan segmen",
  floating_button: "Tombol mengambhang",
  follow_up: "Follow-up",
  footer: "Footer",
  for_optimized_design: "Untuk desain yang dioptimalkan, pertahankan deskripsi kamu dalam 160 karakter",
  form: "form",
  form_example: "Contoh Form",
  form_name: "Nama Form",
  form_url: "URL Form",
  format: "Format",
  forms_not_found: "Forms tidak dijumpai",
  free_shipping: "Pengiriman GRATIS",
  from: "Dari",
  from_yesterday: "dari kemarin",
  fulfilment_method: "Jenis pengiriman",
  fundraiser: "Penggalangan dana",
  fundraisers: "Penggalangan dana",
  gateway: "gerbang",
  general: "Umum",
  generate: "Buat",
  generate_qr_code: "Buat kode QR",
  generate_qr_code_description: "Buat dan kelola kode QR untuk setiap tabel.",
  generating_share_url: "Membuat URL berbagi",
  go_to_link: "Buka tautan",
  goal_desc: "Tambahkan bilah donasi ke halaman Anda",
  goal_optional: "Tujuan (opsional)",
  got_it: "Got it",
  hardware_settings: "Pengaturan perangkat keras",
  hardware_settings_description: "Koneksi perangkat keras ke POS",
  has_inventory: "Produk ini memiliki stok terbatas",
  header: "Header",
  help_center: "Bantuan",
  hidden: "Sembunyi",
  hide_soldout_product: "sembunyikan produk habis",
  history_of_payment: "Riwayat pembayaran",
  holidays: "Liburan",
  home: "Beranda",
  iframe: "iFrame",
  images: "Foto",
  in_stock: "Tersedia",
  include: "Masukkan",
  include_addons: "Sertakan add-ons",
  include_product_image: "Sertakan gambar produk",
  include_product_video: "Sertakan video produk",
  include_variants: "Sertakan varian",
  income: "Pendapatan",
  income_invoice: "Invois pendapatan",
  info_message: {
    confirmation_code_sent_to: "Kode konfirmasi dikirim ke {text}",
    domain_request_sent: "Permintaan domain kamu telah terkirim",
    tac_sent_to: "TAC dikirim ke {text}",
  },
  insert_field: "Tambahkan Field",
  inventory: "Inventaris",
  invite: "Undang",
  invite_member: "Undang Member",
  invite_new_admin: "Undang admin baru",
  invite_new_member: "Undang anggota baru",
  invited_list: "Daftar undangan",
  invoice: "Invois",
  invoice_link: "Link invoice",
  item: "Item",
  item_list: "Daftar Item",
  items: "Item",
  items_ordered: "Item dipesan",
  keep_working: "Teruskan",
  label: "Label",
  last_updated_on: "Terakhir diperbarui saat",
  layouts: "Layout",
  lead: "Lead",
  leads: "Lead",
  learn_more: "Pelajari lebih lanjut",
  learn_more_about: "Pelajari lebih lanjut tentang",
  leave_feedback: "Tinggalkan Umpan Balik",
  leave_us_message: "Tinggalkan pesan",
  left_in_stock: "stok tersisa",
  list_view: "Tampilan daftar",
  list_view_desc: "Tampilan halaman untuk melihat pesanan kamu lebih mudah",
  load_more: "muat lagi",
  loading: "Memuat",
  local_delivery: "Pengiriman lokal",
  log_in: "Log in",
  looking_good: "Kelihatan Bagus!",
  low_balance: "Saldo rendah",
  manage: "Kelola",
  manage_addons: "mengatur add-ons",
  manage_campaign: "Kelola kampanye",
  manage_forms: "Kelola form",
  manage_inventory: "Kelola Stok",
  manage_member: "Kelola member",
  manage_shipping_zones: "Kelola Zona Pengiriman",
  mark_as_paid: "Tanda bayar",
  max_image_filesize: "Maksimal ukuran file 10 MB",
  max_video_filesize: "Maksimal ukuran file 30 MB",
  maybe_later: "Nanti saja",
  members_not_found: "Member tidak ditemukan",
  menu: "Menu",
  menu_category: "Kategori Menu",
  message: "Pesan",
  message_preview: "Pratinjau pesan",
  message_template: "Template Pesan",
  meta_description: "Sub Deskripsi (SEO)",
  meta_title: "Sub Judul (SEO)",
  method: "Metode",
  min_order_amount: "Jumlah pesanan minimum",
  missing_features: "Fitur tidak ada",
  month: "bulan",
  monthly: "bulanan",
  more: "Lainnya",
  more_details: "Detail lebih lanjut",
  multiple_date: "Beberapa tanggal",
  name: "Nama",
  name_on_card: "Nama di Kartu",
  new: "Baru",
  new_campaign: "Kampanye baru",
  new_features: "Fitur baru",
  new_segment: "Segmen Baru",
  new_task: "Tugas baru",
  new_user: "Pengguna Baru",
  newest: "Terbaru",
  next: "Lanjut",
  no: "Tidak",
  no_categories_yet: "Kategori tidak ditemukan",
  no_change_subscription: "Tiada perubahan dalam berlangganan",
  no_customer_available: "Tidak ada pelanggan yang tersedia",
  no_customer_found: "Tiada pelanggan ditemukan",
  no_file_selected: "Tidak ada file yang dipilih",
  no_inventory: "Tiada Inventaris",
  no_item_found: "Tiada item ditemukan",
  no_limit: "Tiada batas",
  no_list_available: "Tidak ada daftar yang tersedia",
  no_members_available: "Tidak ada anggota yang tersedia",
  no_orders_adjust_filter: "Coba sesuaikan pilihan filter kamu.",
  no_orders_found: "Tiada pesanan dijumpai.",
  no_record_error_found: "Tidak ditemukan kesalahan pencatatan",
  no_segments_available: "Tidak ada segmen yang tersedia",
  no_tasks_available: "Tidak ada tugas yang tersedia",
  not_arranged_yet: "Belum diatur",
  note: "Pesan",
  notifications: "Notifikasi",
  now: "Sekarang",
  number_of_table: "Jumlah tabel",
  offers: "Diskon",
  oldest: "Terlama",
  on_demand: "On-Demand",
  one_month: "1 Bulan",
  one_week: "1 Minggu",
  one_year: "Setahun",
  only_count_left_in_stock: "Hanya {qty} stok tersisa",
  only_when_low: "Hanya saat rendah",
  open: "Buka",
  or: "atau",
  order: "Pesanan",
  order_created: "Pesanan dibuat",
  order_delivered: "Order diterima",
  order_id: "Order ID",
  order_items: "Item pesanan",
  order_limit: "Batas Pesanan",
  order_scheduled: "Pesanan dijadwalkan",
  order_settings: "Pengelolaan Pesanan",
  order_shipped: "Pesanan dikirim",
  orders: "Pesanan",
  other: "Lainnya",
  overdue: "Jatuh tempo",
  packing_slips: "Slip Pengepakan",
  page_views: "Tampilan halaman",
  pages: "Halaman",
  pass_service_fee: "Biaya layanan lulus",
  past_7_days: "7 hari yang lalu",
  paste_video_url: "Tempel url video di bawah",
  paste_video_url_desc: "Sematkan video dari Youtube, Facebook, Twitch & Vimeo saja",
  pay_at_shop: "bayar di toko",
  pay_before: "bayar sebelum",
  pay_now: "Bayar sekarang",
  payment: "Pembayaran",
  payment_and_checkout: "Pembayaran & checkout",
  payment_and_checkout_desc: "Konfigurasikan opsi pembayaran dan checkout untuk kampanye Anda",
  payment_gateway_details: "Aktifkan Kartu Kredit/Debit dan Pembayaran FPX (Online Banking)",
  payment_method: "Metode Pembayaran",
  payment_options: "Opsi pembayaran",
  payment_options_description: "Kelola opsi pembayaran untuk pemesanan meja.",
  payment_settings: "Setelan pembayaran",
  payment_settings_description: "Kelola pengaturan pembayaran POS",
  payment_status: "Status pembayaran",
  payment_type: "Jenis Pembayaran",
  payments: "Pembayaran",
  payout_amount: "Jumlah Pembayaran",
  payouts: "Payout",
  pending_invites: "undangan tertunda",
  pending_payment: "Pembayaran tertunda",
  phone: "Telepon",
  phone_number: "Nomor HP",
  pick: "Ambil",
  pick_color: "Pilih warna",
  pick_list: "Daftar pesanan",
  pick_up: "Jemput",
  pickup: "Jemput",
  please_complete_payment_before: "Sila selesaikan sebelum",
  please_select_delivery_date: "Silakan pilih tanggal pengiriman",
  pos_setup: "Pengaturan POS",
  pos_user_access: "Akses Pengguna POS",
  powered_by_yezza: "Powered by Yezza",
  preferred: "favorit",
  preview: "Pratinjau",
  price: "Harga",
  print: "Cetak",
  print_qr_code: "Cetak kode QR",
  processing: "Sedang diproses",
  product: "Produk",
  product_categories: "Kategori Produks",
  product_image: "Gambar Produk",
  product_limited_stock: "Produk ini memiliki stok terbatas",
  product_name: "Nama Produk",
  product_notes: "Catatan",
  product_variant: "Product Variant",
  product_video: "Video Produk",
  product_weight_missing: "Produk ini tiada berat",
  products: "Produk",
  products_not_found: "Produk tidak ditemukan",
  products_sold: "Produk dijual",
  profit: "Keuntungan",
  profit_loss: "Untung & Rugi",
  promo_banner: "Promo banner",
  promo_description: "Deskripsi Promo",
  promo_discount: "Diskon Promo",
  publish_banner: "Tampilkan banner",
  qr_code: "Kode QR",
  qr_code_desc: "Cetak dan pindai Kode QR ini untuk ditautkan langsung ke {item} Anda.",
  qty: "Kuantitas",
  quick_action: "Aksi cepat",
  quick_links: "Tautan cepat",
  rank: "Peringkat",
  rate: "Tarif",
  ready: "Pesanan Telah Siap",
  rearrange: "Atur kembali",
  receipt: "Tanda terima",
  receipt_preview: "Pratinjau tanda terima",
  receipt_template: "Template tanda terima",
  receipt_template_description: "Sesuaikan informasi yang ditampilkan pada tanda terima",
  recipient: "Penerima",
  recipient_address: "Alamat penerima",
  recommended_image_size: "Ukuran gambar yang disarankan 960x960 px",
  recommended_logo_size: "Ukuran logo yang disarankan 640x160 px (rasio aspek 4:1)",
  recommended_video_size: "Rasio aspek video yang disarankan 1:1",
  record: "Catat",
  record_date: "Tanggal catatan",
  record_error: "kesalahan rekam",
  records_were_found: "catatan ditemukan",
  ref_id: "ID Referensi",
  reference_id: "ID Referensi",
  register: "daftar",
  reload: "muat ulang",
  remarks: "catatan",
  reminder: "Pengingat",
  reminders: "Pengingat",
  remove: "Hapus",
  remove_assignee: "Hapus penerima tugas",
  remove_assignee_confirmation_1: "Apakah Anda yakin ingin menghapus penerima tugas ini?",
  remove_assignee_confirmation_2: "Penerima tugas ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini",
  remove_card: "Hapus kartu",
  remove_customer_segment: "Hapus pelanggan dari segmen",
  remove_customer_segment_confirmation_1: "Apakah Anda yakin ingin menghapus pelanggan ini dari segmen ini?",
  remove_customer_segment_confirmation_2: "Pelanggan ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini.",
  remove_field: "Remove field",
  remove_invites: "Hapus undangan",
  remove_invites_confirmation_1: "Apakah Anda yakin ingin menghapus orang tersebut dari daftar undangan?",
  remove_invites_confirmation_2: "Orang ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini.",
  remove_member: "Hapus anggota",
  remove_member_confirmation_1: "Apakah Anda yakin ingin menghapus anggota dari tim Anda?",
  remove_member_confirmation_2: "Orang ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini.",
  remove_selected: "Hapus yang dipilih",
  remove_variants: "Hapus varian",
  remove_video: "Hapus Video",
  renew_subscription: "Perbarui Langganan",
  repeat_this_order: "Ulang order ini",
  reports: "Laporan",
  require_min_donation_amount: "Memerlukan jumlah donasi minimum",
  required: "diperlukan",
  resend: "Hantar semula",
  reset: "Setel ulang",
  reset_to_default: "Setel ulang",
  restaurant: "Restoran",
  retry: "Coba lagi",
  return_to_subscription: "Kembali ke langganan",
  reupload_csv: "Unggah ulang CSV",
  role: "Peran",
  sales: "Penjualan",
  sales_date: "Tanggal Jualan",
  sales_page: "Sales Page",
  sales_pages: "Sales Page",
  sales_team: "Member & Peran",
  save: "Simpan",
  save_and_continue: "Simpan dan teruskan",
  save_changes: "Simpan perubahan",
  save_variants: "Simpan varian",
  scheduled_date_time: "Tarikh dan masa dijadwalkan",
  scheduling: "Penjadwalan",
  search: "Cari",
  search_bundle: "Cari Bundle",
  search_category: "Kategori pencarian",
  search_customer: "Cari pelanggan",
  search_donors: "Cari donatur",
  search_engine_optimization: "Optimasi Mesin Pencari (SEO)",
  search_engine_optimization_desc: "Opsi SEO mengontrol apa yang dilihat donor Anda saat melihat item ini di mesin pencari. Anda dapat mengisinya sendiri. Atau, jika Anda mau, kami akan menggunakan informasi item default Anda.",
  search_form: "Cari Form",
  search_fundraiser: "Cari penggalangan dana",
  search_member: "Cari member",
  search_order: "Cari Pesanan",
  search_product: "Cari Produk",
  search_segments: "Cari segment",
  search_tasks: "Cari tugas",
  segment_detail: "Rincian segmen",
  segments: "Segmen",
  select: "Pilih",
  select_bank: "Pilih bank",
  select_coupon: "Pilih Kupon",
  select_new: "Pilih baru",
  select_paper_size: "Pilih ukuran kertas",
  select_plan: "Pilih plan",
  select_product: "Pilih produk",
  select_shipping_method: "Pilih metode pengiriman",
  select_shipping_zones: "Pilih zona pengiriman",
  select_source: "Pilih Source",
  selected_courier_unavailable: "Kurir yang dipilih tidak tersedia",
  selected_customers_will_added_to_segment: "Setiap pelanggan yang dipilih akan ditambahkan ke segmen secara otomatis",
  selected_option: "Pilihan yang dipilih",
  self_pickup: "Pengambilan sendiri",
  sellers: "Penjual",
  send: "Kirim",
  send_fb_test_event: "Kirim acara uji coba facebook",
  send_message: "Kirim pesanan",
  send_message_placeholder: "Ini akan menjadi input untuk teks panjang. Ini dapat berisi teks yang lebih panjang. Ketika input melebihi ukuran vertikal bidang ini, mekanisme pengguliran akan diaktifkan.",
  send_message_to_customer: "Kirim pesan ke pelanggan Anda",
  send_message_to_customer_desc: "Tulis pesan Anda untuk dikirim ke pelanggan di bawah",
  send_reminder: "Hantar pengingat",
  send_sms: "Kirim SMS",
  send_to_customer: "Send to Customer",
  sent_to: "Dikirim ke",
  seo_description: "Deskripsi SEO",
  seo_description_desc: "Ini adalah deskripsi yang akan digunakan saat berbagi di media sosial",
  seo_photo: "Foto SEO",
  seo_photo_desc: "Ini adalah thumbnail yang akan digunakan saat berbagi di media sosial",
  seo_title: "Judul SEO",
  seo_title_desc: "Judul tertaut yang dilihat pengguna di hasil pencarian",
  service: "Ekspedisi",
  service_fee: "Tarif Servis",
  set_all_height_to: "Tetapkan semua tinggi ke",
  set_all_length_to: "Tetapkan semua panjang ke",
  set_all_price_to: "Tetapkan semua harga ke",
  set_all_stock_to: "Tetapkan semua stok ke",
  set_all_weight_to: "Tetapkan semua berat ke",
  set_all_width_to: "Tetapkan semua lebar ke",
  set_amount: "Tetapkan Jumlah",
  set_minimum_amount: "Tetapkan jumlah minimum",
  set_product_weight: "Tetapkan berat produk",
  set_shipping_date: "Tetapkan tanggal pengiriman",
  set_shipping_time: "Tetapkan jam pengiriman",
  set_variant_details: "Tetapkan Detail varian",
  settings: "Pengaturan",
  setup: "Atur",
  setup_account: "Buat akun",
  setup_number_of_tables: "Setel jumlah tabel",
  share: "Bagikan",
  share_invoice: "Bagikan invoice",
  share_invoice_link_by: "Bagikan tautan invois ke",
  share_to_whatsapp: "Bagikan ke WhatsApp",
  share_url_by: "Bagikan URL",
  share_your_agent_links: "Bagikan tautan agen kamu",
  sharing: "Berbagi",
  ship_to: "Kirim ke",
  ship_to_this_address: "Kirim ke alamat ini",
  shipping: "Pengiriman",
  shipping_address: "Alamat pengiriman",
  shipping_and_delivery: "Pengiriman dan Penghantaran",
  shipping_date: "Tarikh pengiriman",
  shipping_error: "Kesalahan pengiriman",
  shipping_method: "Methode pengiriman",
  shipping_tab: "dikirim",
  shipping_time: "Waktu pengiriman",
  shipping_zone: "Zona pengiriman",
  show: "Tampilkan",
  show_an_other_option: "Tampilkan opsi 'Lainnya' untuk mengizinkan donor memasukkan jumlah khusus yang ingin disumbangkan",
  show_customers: "Tampilkan pelanggan",
  show_donors: "Tampilkan donatur",
  show_fundraiser: "Tampilkan penggalangan dana",
  show_less: "Tampilkan lebih sedikit",
  show_more: "Tambilkan lebih lanjut",
  show_segments: "Tampilkan segmen",
  show_tasks: "Tampilkan tugas",
  sign_in: "Log in",
  sign_out: "Log keluar",
  single_date: "Hanya satu tanggal",
  six_digit_code: "Kode 6 digit",
  small_receipt: "Saiz kecil tanda terima",
  sms_blast_report: "SMS blast report",
  sold_out: "Sold out",
  sort: "Urutkan",
  sort_products: "Urutkan Produk",
  source: "Source",
  start: "Mula",
  start_form_creation: "Mulai Membuat WhatsApp form kamu. Bagikan, Klik, Bayar.",
  start_sending_message: "mulai mengirim pesan",
  status: "Status",
  stock: "Stok",
  stock_up_soon: "Segera di stok",
  store_pickup: "Pengambilan di toko",
  story: "Cerita",
  story_desc: "Tambahkan cerita ke kampanye Anda. Ini muncul langsung di bawah judul dan foto sampul.",
  submit: "Hantar",
  submit_ideas: "Kirim Kritik dan Saran",
  subscribe_now: "Berlangganan sekarang",
  subscribed_addons: "Add-on berlangganan",
  subscription: "Berlangganan",
  subtotal: "Subtotal",
  success: "Berhasil",
  success_message: {
    address_copied_to_clipboard: "Alamat disalin ke clipboard kamu",
    address_updated: "Alamat diperbarui",
    assignee_removed_successfully: "Penerima tugas berhasil dihapus",
    business_hour_updated: "Jam kerja diperbarui",
    card_successfully_added: "Kartu berhasil ditambahkan",
    card_successfully_deleted: "Kartu berhasil dihapus",
    category_changed_draft: "Kategori diubah menjadi draf",
    category_created: "Kategori dibuat",
    category_published_successfully: "Kategori berhasil diterbitkan",
    category_updated: "Kategori diperbarui",
    code_copied_to_clipboard: "Kode disalin ke clipboard kamu",
    commissions_processed: "Komisi diproses",
    content_copied_to_clipboard: "Konten disalin ke papan klip Anda",
    coupon_added: "Kupon ditambahkan",
    coupon_code_applied: "Kode kupon diterapkan",
    coupon_code_removed: "Kode kupon dihapus",
    coupon_edited: "Kupon diedit",
    customer_added_segment_successfully: "Pelanggan berhasil ditambahkan ke segmen",
    customer_created: "Pelanggan dibuat",
    customer_edited: "Pelanggan diedit",
    customers_deleted_successfully: "Pelanggan berhasil dihapus",
    campaign_deleted_successfully: "Kampanye berhasil dihapus",
    donors_deleted_successfully: "Donatur berhasil dihapus",
    customers_successfully_removed_from_segment: "{count} pelanggan telah berhasil dikeluarkan dari segmen ini",
    email_successfully_updated: "Alamat email berhasil diperbarui",
    email_successfully_verified: "Email berhasil diverifikasi",
    expense_recorded_successfully: "Biaya berhasil dicatat",
    form_created: "form dibuat",
    form_duplicated: "Form duplicated",
    form_updated: "form diperbarui",
    image_added: "Gambar ditambahkan",
    image_updated: "Gambar diperbarui.",
    income_edited: "Penghasilan diedit",
    income_recorded_successfully: "Pendapatan berhasil dicatat",
    invitation_deleted: "Undangan dihapus",
    invitation_sent: "Undangan terkirim",
    invitation_sent_successfully: "Undangan berhasil dikirim",
    link_copied_to_clipboard: "Tautan disalin ke papan klip kamu",
    mall_edited: "Mal diedit",
    manage_order_disabled: "Kelola pesanan dinonaktifkan",
    member_added: "Anggota ditambahkan",
    member_edited: "Anggota diedit",
    member_remove_successfully: "Member berhasil dihapus",
    member_successfully_deleted: "Anggota berhasil dihapus.",
    member_tier_updated: "Tingkat anggota diperbarui",
    minimum_order_updated: "Jumlah pesanan minimum diperbarui",
    new_assignee_added_successfully: "Penerima tugas baru berhasil ditambahkan",
    new_cashier_created: "New cashier was successfully created",
    one_page_checkout_updated: "Checkout satu halaman diperbarui",
    order_cancelled: "Pesanan dibatalkan",
    page_created: "Halaman dibuat",
    page_updated: "Halaman diperbarui",
    payment_edited: "Pembayaran diedit",
    payment_successful: "Pembayaran Berhasil",
    payout_archived: "Pembayaran diarsipkan",
    payout_updated: "Pembayaran diperbarui",
    phone_successfully_updated: "Nomor telepon berhasil diperbarui",
    product_added: "Produk ditambahkan",
    product_commissions_updated: "Komisi produk diperbarui",
    product_edited: "Produk diedit",
    product_successfully_imported: "Produk berhasil diimpor",
    product_updated: "Produk diperbarui",
    profile_updated: "Profil diperbarui",
    promo_banner_updated: "Spanduk promo diperbarui",
    reload_successful: "Muat ulang berhasil",
    reminder_sent: "Pengingat terkirim",
    request_under_processing: "Permintaan kamu sekarang sedang diproses",
    response_recorded: "Respon telah direkam. Terima kasih!",
    sales_popup_updated: "Pop-up penjualan diperbarui",
    segment_created_successfully: "Segmen berhasil dibuat",
    segment_description_changed_successfully: "Deskripsi segmen berhasil diubah",
    segment_not_shown_at_tab: "Segmen tidak akan ditampilkan di tab ekstensi",
    segment_remove_successfully: "Segmen berhasil dihapus",
    segment_shown_at_tab: "Segmen akan ditampilkan di tab ekstensi",
    segment_title_changed_successfully: "Judul segmen berhasil diubah",
    segment_update_successful: "Pembaruan segmen berhasil",
    store_edited: "Toko diedit",
    successfully_saved_bank_account: "Berhasil menyimpan informasi rekening bank perusahaan",
    successfully_updated: "Berhasil diperbarui",
    switched_back_old_checkout: "Beralih kembali ke checkout lama",
    task_created_successfully: "Tugas berhasil dibuat",
    task_name_changed_successfully: "Nama tugas berhasil diubah",
    task_remove_successfully: "Penghapusan tugas berhasil",
    template_updated_successfully: "Template berhasil diperbarui",
    tracking_link_copied_clipboard: "Tautan pelacakan disalin ke papan klip kamu",
    tracking_number_copied_clipboard: "Nomor pelacakan disalin ke papan klip kamu",
    vendor_created: "Vendor dibuat",
    vendor_edited: "Vendor diedit",
    visibility_updated: "Visibilitas diperbarui",
    webhook_integration_success: "Integrasi webhook berhasil diperbarui",
    your_concern_reported: "Kekhawatiran kamu telah dilaporkan untuk penyelidikan.",
    your_idea_recorded: "Ide kamu telah direkam. Terima kasih!",
    zone_successfully_updated: "Zona berhasil diperbarui.",
    provider_deleted_successfully: "Provider deleted successfully",
    service_deleted_successfully: "Service deleted successfully",
    field_deleted_successfully: "Field deleted successfully",
    update_successful: "Update successful",
    delete_successful: "Delete successful",
    category_deleted_successfully: "Category deleted successfully",
    service_assigned_successfully: "Service assigned to category successfully",
    service_reassigned_successfully: "Service reassigned successfully",
    service_removed_successfully: "Service removed successfully",
    photo_deleted_successfully: "Photo deleted successfully",
    item_copied_to_clipboard: "{item} copied to your clipboard",
    new_api_key_generated: "New API Key has been generated",
    csv_imported_successfully: "CSV imported successfully",
    medication_added_successfully: "Medication added successfully",
    tax_added_successfully: "Tax added successfully",
    successfully_send_to_printer: "Successfully sent to printer",
    preset_updated_successfully: "Preset updated successfully",
    panel_created: "Panel created successfully",
    panel_updated: "Panel updated successfully"
  },
  switch_company: "Toko kamu",
  sync_products: "Sinkronkan Produk",
  synced: "Disinkronkan",
  table_available: "Tabel Tersedia",
  table_ordering: "Pemesanan Tabel",
  tac: "TAC",
  task_detail: "Rincian tugas",
  task_not_found: "Tugas tidak ditemukan",
  tasks: "Tugas",
  tax: "Tarif pajak",
  test: "Test",
  test_event_code: "Uji kode peristiwa",
  text_color: "Warna Teks",
  thank_you_message: "Pesan terima kasih",
  thank_you_message_desc: "Tulis pesan terima kasih khusus yang akan muncul di halaman sukses setelah pembayaran.",
  this_computer_generated_invoice: "Ini adalah invois yang dibuat oleh komputer. Tidak perlu tanda tangan.",
  this_computer_generated_receipt: "Ini adalah tanda terima yang dibuat oleh komputer. Tidak perlu tanda tangan.",
  this_is_computer_generated: "This is computer generated document. No signature required.",
  this_month: "Bulan ini",
  this_person_received_invitation_email: "Orang ini akan menerima undangan melalui email mereka",
  this_week: "Minggu ini",
  this_year: "Tahun ini",
  three_month: "3 Bulan",
  title: "Judul",
  today: "Hari ini",
  too_slow: "Terlalu lambat.",
  total: "Total",
  total_donors: "Total donatur",
  total_leads: "Total potensi pelanggan",
  total_sales: "total penjualan",
  total_views: "Total dilihat",
  total_weight: "Berat Total",
  track: "Lacak",
  track_your_parcel: "Lacak paket kamu",
  tracking_info: "Info pelacakan",
  tracking_number: "Nomor pelacakan",
  transaction_details: "detail transaksi",
  transaction_history: "Riwayat transaksi",
  transactions: "Transaksi",
  type_in_segment_name: "Nama segmen",
  unpaid_invoices: "Invois belum berbayar",
  until: "Hingga",
  update: "Perbarui",
  update_bank: "Perbarui Bank",
  update_status: "Perbarui Status",
  update_tracking_info: "Perbarui info pelacakan",
  update_weight: "Perbarui berat",
  upload: "Unggah",
  upload_and_continue: "Unggah dan lanjutkan",
  upload_image: "Unggah foto",
  upload_photo: "Unggah foto",
  upload_photo_1_mb: "Unggah foto. (Ukuran maksimal 1MB)",
  user_settings: "Pengaturan pengguna",
  user_settings_description: "Kelola peran pengguna, akses POS",
  username: "Nama pengguna",
  users: "Pengguna",
  value_must_be_in_number: "Nilai harus dalam angka",
  variant_name: "Nama Varian",
  variant_type: "Jenis Varian",
  variants: "Varian",
  verify: "verifikasi",
  video_url: "URL Video",
  view_all_addons: "lihat semua add-ons",
  view_all_variants: "lihat semua varian",
  view_form: "lihat form",
  view_history: "Lihat Riwayat",
  view_invoice: "lihat invoice",
  view_job_list: "lihat senarai kerja",
  view_page: "Lihat halaman",
  view_receipt: "lihat tanda terima",
  views: "Dilihat",
  wallet: "dompet",
  webhook: "webhook",
  webhook_integration: "Integrasi Webhook",
  week: "minggu",
  weight: "Berat",
  weight_kg: "Berat (KG)",
  what_look_like: "Pratinjau",
  whatsapp_forms: "WhatsApp Form",
  whos_selling: "Penjual",
  within_num_days: "dalam {num} hari",
  year: "tahun",
  yes: "Ya",
  yesterday: "Kemarin",
  yesterday_at: "Kemarin pada",
  yezza_store: "Yezza Store",
  yezza_store_features: "Fitur Yezza Store",
  you_are_currently_using: "Anda sedang menggunakan",
  you_can_insert_field_into: "Anda dapat memasukkan bidang ke dalam template Anda",
  your_language: "Bahasa kamu",
  zone: "Zona",
  confirmation_send_message_donor: "Are you sure you want to send this message to your donors?",
  you_cant_undo_send_message: "You can’t undo this action once you sent the message. Click “Send” to proceed.",
  event_name: "Event name",
  email_blast_report: "Email blast report",
  performance: "Performance",
  total_sms_sent: "Total SMS sent",
  success_rate: "Success rate",
  sent_sms: "Sent SMS",
  sent_on: "Sent on",
  event: "Event",
  email_sent: "Email sent",
  total_opens: "Total opens",
  unsubscribed: "Unsubscribed",
  open_rate: "Open rate",
  blast_email: "Blast Email",
  delete_campaign: "Delete campaign",
  send_email: "Send Email",
  send_email_to_customer: "Send email to your customer",
  send_email_to_customer_desc: "Write your email to be sent to customer below",
  confirmation_send_email_donor: "Are you sure you want to send this email to your donors?",
  email_preview: "Email Preview",
  send_email_placeholder_1: "Subject: Promotion on the product",
  send_email_placeholder_2: "This would be the input for long text. It can contain longer text. When the input exceeds the vertical size of this field, scrolling mech will be enabled.",
  you_cant_undo_send_email: "You can’t undo this action once you sent the email. Click “Send” to proceed.",
  subject: "Subject",
  type_something: "Type something",
  sharing_embed: "Add this campaign to a website",
  sharing_embed_desc: "Copy this code snippet and paste it onto your website where you'd like the form to appear.",
  how_to_add_campaign: "How to do you want to add this campaign to your website?",
  as_a_floating_button: "As a floating button",
  as_a_page: "As a page (iFrame)",
  choose_link: "Choose link",
  donation_page: "Donation page",
  donation_form: "Donation form",
  get_code: "Get code",
  copy_paste_embed: "Copy and paste in your website editor",
  embed_code: "Embed code",
  copy_code: "Copy code",
  appointment: "Appointment",
  patient: "Patient",
  add_segment: "Add segment",
  confirmation_send_message_customers: "Are you sure you want to send this message to your customers?",
  confirmation_send_email_customers: "Are you sure you want to send this email to your customers?",
  add_donor: "Add donor",
  campaign_ranking: "Peringkat Kampanye",
  fundraiser_ranking: "Peringkat Penggalang Dana",
  optional_tips: "Nonaktifkan kiat",
  optional_tips_desc: "Minta pendukung untuk meninggalkan tip opsional untuk Yezza. Mengaktifkan ini akan meningkatkan biaya platform Anda dari 0% menjadi 5%.",
  transfer_transaction_fee: "Membuat biaya diperlukan",
  transfer_transaction_fee_desc: "Aktifkan ini jika Anda ingin donatur menanggung biaya transaksi.",
  recurring_donation: "Paket berulang",
  recurring_donation_desc: "Konfigurasikan opsi pembayaran berulang untuk kampanye Anda. Fitur ini hanya tersedia untuk pembayaran kartu kredit",
  offer_recurring_donation: "Tawarkan paket berulang",
  offer_recurring_donation_desc: "Aktifkan ini jika Anda ingin agar donatur Anda berdonasi dengan cara berulang",
  company_info: "Company info",
  patient_info: "Patient info",
  provider: "Provider",
  search_patient: "Search patients",
  show_patient: "Show patient",
  add_patient: "Add patient",
  delete_donor: "Delete donor",
  enter_email: "Enter email address",
  change_to: "Change to",
  services: "Services",
  patient_form: "Patient form",
  company_name: "Company name",
  new_provider: "New provider",
  empty_providers: "You don’t have any providers yet.",
  empty_providers_desc: "Provider is the person incharge for made service and appointment",
  create_provider: "Create provider",
  create_provider_type: "Create provider type",
  create_new_provider: "Create new provider",
  edit_provider: "Edit provider",
  delete_provider: "Delete provider",
  provider_detail: "Provider’s detail",
  provider_detail_desc: "Set profile image, name and type of provider",
  profile_image: "Profile image",
  provider_name: "Provider’s name",
  provider_name_placeholder: "Enter provider's name",
  type_of_provider: "Type of provider",
  type_of_provider_placeholder: "Choose type of provider",
  search_or_add_new: "Search or add new",
  existing_type_of_provider: "Existing type of provider",
  provider_availability: "Provider’s availability",
  provider_availability_desc: "Set the availibility for this provider",
  configure_times_available: "Configure times you are available for work",
  set_weekly_hours: "Set weekly hours",
  add_date_overrides: "Add date overrides",
  add_date_overrides_desc: "Add dates when your avalability changes from your weekly hours",
  add_date_override: "Add a date override",
  unavailable: "Unavailable",
  copy_timing_to: "Copy timing to",
  select_dates_override: "Select the date(s) you want to override with specific hours",
  set_new_timing: "Set new timing for selected date",
  set_new_timing_desc: "This will be overidden on top of your default schedule. Delete all timings to make this date unavailable.",
  integration: "Integration",
  integration_details: "Custom domain and webhook settings",
  provider_service: "Provider’s service",
  provider_service_desc: "Set the service for this provider",
  configure_type_services: "Configure type of services that this provider provide",
  add_service: "Add service",
  empty_assign_services: "You don’t assign any services yet.",
  empty_assign_services_desc: "You can start assign services by clicking “+ Add service” ",
  new_service: "New service",
  booking_fee: "Booking fee",
  duration: "Duration",
  edit_service: "Edit service",
  delete_service: "Delete service",
  create_service: "Create service",
  create_new_service: "Create new service",
  service_details: "Service details",
  service_details_desc: "Set the name and duration of the service",
  service_name: "Service name",
  service_name_placeholder: "Enter service name",
  service_description: "Service description",
  service_description_placeholder: "Enter description",
  service_duration: "Service duration",
  delete_confirmation: "Apakah Anda yakin ingin menghapus {text} ini?",
  delete_confirmation_desc: "{text} ini akan segera dihapus. Anda tidak dapat membatalkan tindakan ini.",
  how_many_times_service: "How many times can this service be done at one time? (Optional)",
  how_many_times_service_desc: "Please consider limitation on machines and rooms",
  unlimited_times: "Unlimited times",
  limited_times: "Limited times",
  limited_times_desc: "Type in amount of times this service can be done at one time",
  times_at_one_time: "time(s) at one time",
  when_patients_schedule: "When can patients schedule appointment?",
  when_patients_schedule_desc: "Set a range of dates when you can accept appointments from patients",
  patient_must_schedule: "Patient must schedule appointment",
  before_appointment_start: "before an appointment start time",
  is_booking_fee_required: "Is booking fee required to schedule for this service?",
  type_booking_fee_amount: "Type in booking fee amount",
  preliminary_questions_opt: "Preliminary questions (Optional)",
  preliminary_questions_opt_desc: "Some services may need some preliminary required questions to be asked to the patient. Eg: In what week is your pregnancy now?",
  create_preliminary_question: "Create preliminary question",
  empty_services: "You don’t have any services yet.",
  empty_services_desc: "Service determine the type of appointment that patient makes",
  empty_assign_providers: "You don’t assign any providers yet.",
  empty_assign_providers_desc: "You can start assigning provider by clicking “+ Add provider” ",
  add_provider: "Add provider",
  Who_service_conducter: "Who can do this service?",
  Who_service_conducter_desc: "who can conduct this service, time slot available will be depending on providers timing",
  providers_list: "Providers list",
  services_list: "Services list",
  patient_information_form: "Patient’s information form",
  patient_information_form_desc: "Manage your patient information form",
  telephone_number: "Telephone number",
  id_info: "NRIC/Passport",
  add_field: "Add field",
  create_input_field: "Create new input field",
  fill_the_information_below: "Fill the information below",
  input_type: "Input type",
  label_title_of_question: "Label (Title of question)",
  placeholder: "Placeholder",
  placeholder_desc: "This will appear on your field before filling",
  is_required: "Is required",
  select_input_type: "Select input type",
  enter_label_name: "Enter label name",
  enter_answer: "Enter answer",
  add_answer: "Add answer",
  list_of_answers: "List of answers",
  enter_placeholder: "Enter placeholder",
  field: "Field",
  create_question_field: "Create preliminary question field",
  label_title_of_the_question: "Label (Title of question / the question)",
  add_question: "Add question",
  upcoming: "Upcoming",
  no_show: "No-show",
  cancelled: "Cancelled",
  whatsapp_message_template: "WhatsApp message template",
  whatsapp_message_template_desc: "Setup this message to send reminder to patients in just one-click",
  upcoming_reminder_template: "Upcoming reminder template",
  upcoming_reminder_template_desc: "Write an upcoming reminder template message that will send to your patient.",
  current_template: "Current template",
  current_template_placeholder: "Hi Sarah Danial!\r\nWe see that you missed your appointment with Dr Jamal at 2:00 PM.\r\nWould you like to book another appointment? You can do so here:\r\nclinic.yezza.co/appointment",
  review_reminder_template: "Thank you message template",
  review_reminder_template_desc: "Write an review template message that will send to your patient.",
  edit_template: "Edit template",
  no_show_reminder_template: "No-show reminder template",
  no_show_reminder_template_desc: "Write an no-show template message that will send to your patient.",
  new_appointment: "New appointment",
  fill_up_appointment_details: "Please fill up the appointment details",
  service_type: "Service type",
  select_service_type: "Select service type",
  doctor: "Doctor",
  select_doctor: "Select doctor",
  appointment_date: "Appointment date",
  select_appointment_date: "Select appointment date",
  available_time: "Available time",
  select_available_time: "Select available time",
  type_patient_identification: "Type in patient’s identification number",
  nric_passport: "NRIC / Passport",
  enter_nric_passport: "Enter NRIC or Passport",
  email_optional: "Email (Optional)",
  phone_optional: "Phone number (Optional)",
  address_optional: "address (Optional)",
  booking_fees: "Booking fees",
  this_service_requires_payment: "This service requires payment, you may record it now",
  this_service_doesnt_requires_payment: "This service doesn’t require payments. You can proceed to confirm booking.",
  record_payment_now: "Record payment now",
  record_payment_later: "Record payment later",
  select_payment_method: "Select payment method",
  notes_on_payment_optional: "Notes on payment (optional)",
  notes_on_payment: "Notes on payment",
  store_link: "Store link",
  time: "Time",
  confirm_booking: "Confirm booking",
  no_fees_required: "No fees required",
  mark_as_arrived: "Mark as arrived",
  reschedule_new_date: "Reschedule to a new date",
  cancel_this_appointment: "Cancel this appointment",
  cancel_appointment: "Cancel appointment",
  create_followup_appointment: "Create follow-up appointment",
  record_payment: "Record payment",
  mark_patient_arrived_confirmation: "Are you sure you want to mark this patient as arrived?",
  change_appointment_date_time: "Change the appointment date and time",
  patient_details: "Patient’s details",
  why_cancel_appointment: "Why do you want to cancel this appointment? (optional)",
  state_reason_here: "State your reason here",
  last_appointment_date: "Last appointment date",
  choose_appointment_details: "Choose appointment details",
  appointment_details: "Appointment details",
  edit_appointment_details: "Edit appointment details",
  make_change_on_details: "Make change on the following details",
  edit_patient_detail: "Edit patient detail",
  booking_name: "Booking name",
  booking_phone_number: "Booking phone number",
  booking_email: "Booking email",
  preliminary_questions: "Preliminary questions",
  reason_for_cancellation: "Reason for cancellation",
  page_setup: "Page setup",
  booking_fee_desc: "Type in booking fee amount",
  please_use_gmail: "Please Sign Up using Gmail",
  mark_sent_pending: "Mark sent status as pending",
  mark_sent_pending_confirmation: "Are you sure you want to mark this patient sent status to pending?",
  mark_sent_pending_confirmation_desc: "The sent status will be changed to “Pending” immediately. You can’t undo this action.",
  potential_sales: "Potential sales",
  notes: "Notes",
  notes_optional: "Notes (Optional)",
  booking_notes: "Booking notes",
  edit_fundraiser: "Edit fundraiser",
  add_fundraiser: "Add fundraiser",
  raised: "Raised",
  audience: "Audience",
  appointment_page_language: "Appointment page language",
  appointment_page_language_desc: "Configure your preferred language for your appointment page",
  pre_appointment_instruction_optional: "Pre-appointment instruction (Optional)",
  pre_appointment_instruction: "Pre-appointment instruction",
  pre_appointment_instruction_placeholder: "1. Drink water and do not urinate before your ultrasound scan.\n2.",
  pre_appointment_instruction_desc: "Some services may need some pre-appointment instructions to be reminded to the patient. Eg: Drink water and do not urinate before your ultrasound scan.",
  label_title_of_instruction: "Label (Title of instruction)",
  before_appointment: "Before appointment",
  post_appointment_instruction_optional: "Post-appointment instruction (Optional)",
  post_appointment_instruction: "Post-appointment instruction",
  post_appointment_instruction_placeholder: "1. Get plenty of rest as much as possible to cope with fatigue.\n2.",
  post_appointment_instruction_desc: "Some services may need some post-appointment instructions to be reminded to the patient. Eg: Get plenty of rest as much as possible to cope with fatigue. ",
  after_appointment: "After appointment",
  edit_message: "Edit Message",
  tips_to_format: "Tips to Format Text in WhatsApp",
  appointment_link: "Appointment link",
  search_transaction: "Search transaction",
  show_transaction: "Show transaction",
  edit_transaction: "Edit transaction",
  new_donation: "New donation",
  donation_amount_date_created: "Enter donation amount and date created",
  add_more_donation: "Add more donation",
  delete_donation: "Delete donation",
  donation: "Donation",
  first_name: "First Name",
  last_name: "Last Name",
  commission_optional: "Commission (Optional)",
  bank_transfer: "Bank transfer",
  bank_transfer_desc: "Allow patients to pay online via major banks",
  pay_at_counter: "Pay at counter",
  pay_at_counter_desc: "Allow patients to pay manually at counter",
  qr_pay: "QR pay",
  qr_pay_desc: "Allow patients to pay via QR scan",
  manual_payment: "Manual payment",
  manage_your_services: "Manage your services",
  create_category: "Create category",
  category_name: "Category name",
  enter_category_name: "Enter category name",
  assign_service_to: "Assign service to",
  search_service: "Search service",
  assign_more_services_to: "Assign more services to",
  sort_category: "Sort category",
  rearrange_your_category: "Rearrange your category",
  rename_category: "Rename category",
  delete_category_desc: "This category will be deleted immediately. All of the service assigned will be uncategorized. Click 'Confirm' to proceed.",
  type_to_search: "Type to search...",
  reassign_category: "Reassign category",
  remove_from_category: "Remove from category",
  assign_to_category: "Assign to category",
  create_a_service: "Create a service",
  empty_services_category_desc: "Create service before assigning to a category",
  no_service_found: "No service found",
  choose_category: "Choose category",
  last_service: "Last service",
  enter_first_name: "Enter first name",
  enter_last_name: "Enter last name",
  remove_service_confirmation: "Are you sure you want to remove service from this category?",
  remove_service_desc: "This service will be uncategorized. Click 'Confirm' to proceed.",
  rename: "Rename",
  display_service_fee: "Do you want to display full service price?",
  service_fee_amount: "Service fee amount",
  service_photo_optional: "Service photos (optional)",
  service_photo_desc: "For best image optimization, upload JPG image with 1:1 (square) dimension.",
  make_cover_photo: "Make cover photo",
  delete_photo: "Delete photo",
  appt_date_selection_preference: "Appointment date selection preference",
  appt_date_selection_preference_desc: "Configure your preferred date selection in your appointment page",
  show_calendar_first: "Show calendar first",
  show_provider_availability: "Show provider’s availability based on nearest date",
  roles: "Roles",
  user_log: "User log",
  user_roles: "User roles",
  user_roles_desc: "Manage user access to your Clinic Management system",
  edit_user: "Edit user",
  delete_user: "Delete user",
  invite_new_user: "Invite new user",
  admin: "Admin",
  admin_desc: "Access all settings and actions available on Yezza.",
  clinic_assistant: "Clinic assistant",
  clinic_assistant_desc: "Only allow user to manage Appointment & Segments, setup Services & Providers and send WhatsApp, SMS, email to patients.",
  user: "User",
  question: "Question",
  segment: "Segment",
  main_admin: "Main admin",
  // Review
  review: "Review",
  google_review: "Google review",
  feedbacks: "Feedbacks",
  total_review: "Total review",
  all_ratings: "All ratings",
  five_star_review: "5-star review",
  four_star_review: "4-star review",
  three_star_review: "3-star review",
  two_star_review: "2-star review",
  one_star_review: "1-star review",
  invitations: "Invitations",
  get_more_reviews: "Get more reviews",
  review_settings: "Review settings",
  review_setup: "Review setup",
  review_page: "Review page",
  review_page_setup: "Review page setup",
  review_page_setup_description: "Fill in the field to complete your page and email template",
  company_logo_description: "Accepted format: JPG. and PNG.",
  review_page_heading: "Heading",
  review_page_heading_hint: "This would appear as big text in your page",
  review_page_heading_placeholder: "Eg: We would love your feedback",
  review_page_description: "Description",
  review_page_description_placeholder: "Thank you for your visit!\nWe hope you had a great experience with our service. We would really appreciate it if you could take a moment to leave a review.",
  review_page_rating_scale: "Rating scale",
  review_page_rating_scale_description: "Fill in the description and review destination",
  review_page_rating_scale_scale: "Scale",
  review_page_rating_scale_scale_description: "Description*",
  review_page_rating_scale_scale_send_to: "Send to",
  review_page_preview_title: "Preview",
  review_page_preview_rate_question: "How would you rate your experience?",
  email_setup: "Email setup",
  email_setup_description: "Fill in the field to complete your email template",
  email_setup_subject_line: "Email subject line",
  email_setup_subject_line_placeholder: "Enter email subject line here",
  email_setup_subject_line_hint: "The email subject line is only used when sending email",
  email_setup_notification_preview_line: "Email notification preview line",
  email_setup_notification_preview_line_placeholder: "Enter email notification preview line",
  email_setup_notification_preview_line_hint: "This will reflects in your patient’s email notification",
  email_setup_preview_subject_title: "Email subject preview",
  email_setup_preview_notification_title: "Notification preview",
  sms_whatsapp_message_template: "SMS and WhatsApp message template",
  sms_whatsapp_message_template_description: "Write a custom automated message to be sent when requesting review via SMS or WhatsApp",
  sms_whatsapp_message_template_current_template: "Current template",
  sms_whatsapp_message_template_edit_template: "Edit template",
  review_link: "Review link",
  connect_google_business_page: "Connect your Google Business page",
  connect_google_business_page_description: "Use this Google review link to get reviews from your customers.",
  feedback_form: "Feedback form",
  feedback_form_description: "Manage your feedback form",
  feedback_form_description_2: "Manage your feedback form questions",
  google_review_listing_empty_primary_text: "You don’t have any google review yet",
  google_review_listing_empty_secondary_text: "Send review invite to start receiving google review",
  feedback_listing_empty_primary_text: "You don’t have any feedbacks yet",
  feedback_listing_empty_secondary_text: "Send review invite to start receiving feedbacks",
  invitation_listing_empty_primary_text: "You don’t have anyone to invite yet",
  invitation_listing_empty_secondary_text: "{text} will show up here",
  invitation_listing_empty_review_text: "Any customer list available for review",
  invitation_listing_empty_clinic_text: "Any completed appointment",
  google_review_assign_item: "Assign to {item}",
  assign_to_item_tooltip_text: "By syncing the review, you can view the {item} details from this page",
  google_review_view_item_details: "View {item} details",
  reply_review: "Reply review",
  post_reply: "Post reply",
  replied: "Replied",
  response: "Response",
  your_response: "Your response",
  reassign_to_another_item: "Reassign to another {item}",
  unassign_this_item_from_review: "Unassign this {item} from review",
  add_internal_notes: "Add internal notes",
  internal_notes: "Internal notes",
  your_notes: "Your notes",
  send_review_invite: "Send review invite",
  invite_via: "Invite via",
  reload_now_to_send_message: "Reload now to start sending message",
  invite_via_whatsapp: "Invite via WhatsApp",
  invite_via_email: "Invite via email",
  invite_via_message: "Invite via message",
  start_sending_review_requests: "Start sending review requests from the table below ",
  dismiss: "Dismiss",
  review_delete_confirmation_description_primary: "{text} will be removed immediately",
  review_delete_confirmation_description_secondary: "You can't undo this action. Click “Confirm” to proceed.",
  connect_google_review: "Connect your Google Review",
  connect_google_review_description: "Start collecting new reviews, syncing current reviews and responding to reviews in one place",
  connect_now: "Connect now",
  add_review_site: "Add review site",
  google_account: "Google account",
  select_connection: "Select a {connectionType} to connect to",
  select_connection_description: "Confirm which {connectionType} in your Google business that you would like to connect your review to",
  confirm_connection: "Confirm connection",
  confirm_connection_description: "You are about to connect {connection} {connectionType} to {company} review. To edit this, press “Back” or",
  change_connection: "change {connectionType}",
  reconnect: "reconnect",
  google_review_link: "Google Review link",
  how_to_find_google_review_link: "How to find your Google Review link",
  paste_google_review_link: "Paste your Google Review link here",
  google_review_link_placeholder: "https://g.page/r/xxxxxxxxxxxxx/review",
  review_error_message: "Oopss.. Something went wrong. Kindly contact support for further action",
  review_select_another_account: "Your selected account doesn't have any Google My Business (GMB) {connectionType}. Please connect another account to proceed",
  google_review_response: "Google review response",
  invited: "Invited",
  error_stats: "Unable to show stats data due to error. Kindly contact support for further action",
  assign_item: "Assign {item}",
  assign_item_description: "Select which {item} to assign the review with:",
  select_item: "Select {item}",
  select_item_placeholder: "Choose {item}...",
  unassign_review: "Are you sure you want to unassign this review?",
  unassign_item_description: "The {item} assigned will be removed immediately. You can’t undo this action. Click “Confirm” to proceed.",
  item_not_found: "No {item} found",
  item_not_found_description: "Please try another filter/search or clear your filter/search selection",
  filter_cleared: 'Filter cleared',
  filter_rating: 'Filter Rating',
  filter_status: 'Filter Status',
  filter_reply_status: 'Filter Reply Status',
  filter_last_update: 'Filter Last Update',
  filter_last_appointment_update: 'Filter Last Appointment Update',
  filter_last_appointment_update_description: 'Filter appointment completed on:',
  filter_review_made_on: "Filter review made on:",
  choose_rating_to_filter: "Choose the rating that you want to filter:",
  choose_reply_status_to_filter: "Choose the reply status that you want to filter:",
  registration: "Registration",
  consultation: "Consultation",
  insights: "Insights",
  add_new_question: "Add new question",
  on: "On",
  off: "Off",
  active: "Active",
  inactive: "Inactive",
  make_required: "Make this question required",
  enter_title: "Enter title",
  internal_feedback: "Internal feedback",
  submitted_at: "Submitted at",
  download_all_responses: "Download all responses",
  assign_team: "Add taggings",
  feedback_form_preview_title: "Preview",
  submit_feedback: "Submit feedback",
  preview_address: {
    address_1: {
      label: "Address Line 1",
      placeholder: "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    address_2: {
      label: "Address Line 2",
      placeholder: "e.g. IOI Resort City"
    },
    postcode: {
      label: "Postcode",
      placeholder: "e.g. 62502"
    },
    city: {
      label: "City",
      placeholder: "e.g. Putrajaya"
    },
    state: {
      label: "State",
      placeholder: "e.g. Wilayah Persekutuan Putrajaya"
    },
    country: {
      label: "Country",
      placeholder: "e.g. Malaysia"
    }
  },
  api_key: "API key",
  api_key_description: "The following are your API Keys. API keys are used for reading data from Yezza & manipulating some sensitive objects such as lists.",
  api_key_description_2: "API keys should be treated like your password, kept in a safe place and never exposed to the public.",
  no_api_key_title: "You don’t have any API Key yet",
  no_api_key_description: "Start creating API key now to access your API key",
  generate_api_key: "Generate API Key",
  revoke_and_generate_api_key: "Revoke & generate a new key",
  revoke_confirmation_title: "Are you sure you want to revoke your API key?",
  revoke_confirmation_description: "Everything associated with this key will be permenantly deleted.\nThis action cannot be undone.",
  revoke_confirmation_label: "Type “DELETE” to confirm",
  integration_plugin: "Integration and Plugin",
  integration_plugin_general_description : "This API key can be used to connect with Woocommerce, Shopify and other platform.",
  integration_plugin_shopify: "Automatically create review invitation when receiving orders or updating orders in Shopify. Copy the integration link and follow the guide",
  integration_plugin_woocommerce: "Automatically create review invitation when receiving orders or updating orders in WooCommerce. Download and install the Woocommerce Review plugin",
  import_csv: "Import CSV",
  upload_csv: "Upload CSV",
  map_fields: "Map fields",
  choose_a_file: "Choose a file",
  upload_csv_file_containing_users: "Upload a CSV file containing users to invite for review",
  maximum_file_size_1mb: "Maximum file size: 1 MB",
  match_column_labels_to_customers: "Match column labels to customers information",
  columns_have_been_recognize: "column have been recognized in this file. | columns have been recognized in this file.",
  please_map_all_column: "Please map all of the column that you want to import",
  continue_mapping: "Continue mapping",
  finish_mapping: "Finish mapping",
  mapping_field_confirmation_yes: "Yes, continue",
  mapping_field_confirmation_no: "No, I want to make changes",
  csv_import_success_title: "You're good to go.",
  csv_import_success_description: "No error detected. Click Finish to complete setup.",
  csv_import_error_title: "Error detected during the import",
  csv_import_error_description: "{count} customer(s) are affected by these errors. Please fix the error and reupload a new file.",
  sample_data: "Sample data",
  review_automation: "Review Automation",
  review_automation_description: "Automate the process of sending email or SMS to get review from your customers",
  review_automation_sending_type_label: "How to send review link to you customers?",
  review_automation_sending_type_automatic_label: "Automatically send the review",
  review_automation_sending_type_manual_label: "Manually send the review",
  review_automation_sending_method_label: "Choose sending method",
  review_automation_sending_method_sms: "SMS",
  review_automation_sending_method_email: "Email",
  collect_review_after: "Collect review after",
  review_item_details: "{item} details",
  customer_detail: "Customer’s detail",
  edit_item_detail: "Edit {item} detail",
  existing_item: "Existing {item}",
  ignore_and_remove_all_rows_data: "Ignore and remove all rows and data with errors.",
  added_by: 'Added by',
  clinic_appointment_page: 'Clinic Appointment Page',
  payment_date: 'Payment Date',
  payment_details: 'Payment Details',
  // Clinic Management System
  existing_nric_passport: "Existing NRIC / Passport",
  add_new_nric: "Add new NRIC / Passport",
  filter_by: "Filter by",
  type_a_value: "Type a value",
  age: "Age",
  enter_age: "Enter age",
  urgency: "Urgency",
  urgent: "Urgent",
  non_urgent: "Non-urgent",
  arrived_date: "Arrived date",
  to: "To",
  no_doctors_found: "No doctors found",
  serving: "Serving now",
  schedule_for_today: "Schedule for today",
  waiting: "Waiting",
  on_hold: "On hold",
  dispensary: "Dispensary",
  view_profile: "View profile",
  allergy: "Allergy",
  allergies: "Alergi",
  underlying_conditions: "Kondisi yang Mendasari",
  call_patient_in: "Call patient in",
  in_queue: "In-queue",
  put_on_hold: "Put on hold",
  resume_consultation: "Resume consultation",
  complete_consultation: "Complete consultation",
  call_to: "Call to",
  view_all_waiting_patients: "View all waiting patients",
  visit_note: "Visit note",
  allergy_note: "Allergy note",
  item_delete_confirmation_description_primary: "{item} will be removed immediately",
  item_delete_confirmation_description_secondary: "You can't undo this action. Click “Confirm” to proceed.",
  quantity: "Quantity",
  price_tier: "Price Tier",
  dosage: "Dosage",
  frequency: "Frequency",
  instruction: "Instruction",
  precaution: "Precaution",
  out_of_stock: "Out of stock",
  medical_certificate: "Medical certificate",
  date_of_visit: "Date of visit",
  diagnosis: "Diagnosis",
  start_date: "Start date",
  end_date: "End date",
  time_in: "Time in",
  time_out: "Time out",
  enter_item: "Enter {item}",
  reaction: "Reaction",
  add_allergy: "Add allergy",
  self_pay: "Self-pay",
  patient_history: "Patient history",
  visit: "Visit",
  treatments: "Treatments",
  documents: "Documents",
  all_time: "All time",
  past_1_month: "Past 1 month",
  past_3_months: "Past 3 months",
  past_6_months: "Past 6 months",
  past_12_months: "Past 12 months",
  clear_sort: "Clear sort",
  newest_to_oldest: "Newest to oldest",
  oldest_to_newest: "Oldest to newest",
  view_details: "View details",
  record_new_diagnose: "Record a new diagnose",
  attended_by: "Attended by {who}",
  case_notes: "Case notes",
  medication: "Medication",
  services_and_treatments: "Services & Treatments",
  add_to_current: "Add to current",
  add_to_current_plan: "Add to current plan",
  view_all_details: "View all details",
  view_diagnosis: "View diagnosis",
  view_medication_details: "View medication details",
  view_document: "View document",
  choose_and_add_to_current_plan: "You can choose and add to current plan",
  side_effect: "Precaution",
  attach_photo: "Attach photo",
  upload_photo_from_other_device: "Upload photo from other device",
  scan_qr_code_below_to_upload: "Scan QR code below to upload photo from your other devices (Eg: mobile phone, tablet)",
  uploaded: "uploaded",
  over_the_counter: "Over the counter",
  add_item_from_medical_record: "Add item from past medical record",
  download_item: "Download {item}",
  billed_to: "Billed to",
  billing_details: "Billing details",
  change_billing_details: "Change billing details",
  add_adjustment: "Add Adjustment",
  proceed_to_payment: "Proceed to payment",
  balance: "Balance",
  medication_record: "Medication record",
  add_to_dispensary: "Add to dispensary",
  past_medication_record: "Past medication record",
  past_medication_record_description: "Select any record(s) and send it to dispensary",
  send_to_waiting_area: "Send to waiting area",
  go_to_invoice: "Go to invoice",
  summary: "Summary",
  call_in: "Call in",
  print_all_item: "Print all {item}",
  download_all_item: "Download all {item}",
  labels: "Labels",
  edit_item: "Edit {item}",
  photo: "Photo",
  verify_panel_info: "Verify panel info",
  print_item: "Print {item}",
  add_item: "Add {item}",
  adjustment: "Adjustment",
  paid: "Paid",
  amount_due: "Amount due",
  back_to_checkout: "Back to checkout",
  billing_info: "Billing info",
  add_payment_note: "Add payment note",
  add_or_deduct_from_amount: "Would you like to add or deduct from amount?",
  deduct: "Deduct",
  choose_type: "Choose type",
  fixed_amount: "Fixed amount",
  percentage: "Percentage",
  enter_adjustment_amount: "Enter adjustment amount",
  templates: "Templates",
  template: "Template",
  medical_records: "Medical records",
  billings: "Billings",
  in_clinic: "In-clinic",
  clinic_management: "Clinic management",
  business_management: "Business management",
  registration_settings: "Registration settings",
  manage_registration_settings_description: "Set required details in registration",
  consultation_settings: "Consultation settings",
  manage_consultation_settings_description: "Manage preset diagnosis in consultation",
  checkout_settings: "Checkout settings",
  manage_checkout_settings_description: "Manage panel and self-pay payments",
  inventory_and_services: "Inventory & services",
  manage_inventory_description: "Manage your practice items",
  manage_services_description: "Manage your practice services",
  manage_inventory_and_services_settings_description: "Configure your price tiers, medicine details & suppliers",
  patients: "Patients",
  information_and_medical_records: "Information & medical records",
  manage_information_and_medical_records_description: "Patient information & medical records",
  segments_blasting: "Segment and Blasting",
  segments_blasting_description: "Patient Segmentation and Retargetting",
  billing_records: "Billing records",
  manage_billing_records_description: "Access patient medical records",
  import_patients: "Import patients",
  manage_import_patients_description: "Import patient from third-party services",
  appointment_calendar: "Appointment calendar",
  manage_appointment_calendar_description: "List of all appointments",
  manage_appointment_calendar_settings_description: "Configure your appointment system",
  reviews: "Reviews",
  reviews_and_feedbacks: "Reviews & feedbacks",
  manage_reviews_and_feedbacks_description: "List of all reviews & feedbacks",
  manage_reviews_and_feedbacks_settings_description: "Configure your review system",
  manage_queue_settings_description: "Configure your queue system",
  queue: "Queue",
  queue_screen: "Queue screen",
  manage_queue_screen_description: "Open queue screen for display",
  manage_users_description: "Manage your providers",
  rooms_and_equipments: "Rooms & equipments",
  manage_rooms_and_equipments_description: "Manage your rooms & equipments",
  hardware: "Hardware",
  printers: "Printers",
  manage_printers_description: "Configure printers",
  mykad_reader: "MyKad reader",
  manage_mykad_reader_description: "Configure MyKad reader",
  manage_templates_description: "Manage templates for medical records & billings",
  your_business: "Your business",
  business_details: "Business details",
  manage_business_details_description: "Set your business details",
  tax_settings: "Tax settings",
  manage_tax_settings_description: "Setup tax to be used in checkout process",
  payment_gateway: "Payment gateway",
  manage_payment_gateway_description: "Configure your preferred payment gateway",
  user_management: "User management",
  permission: "Permission",
  manage_permission_description: "Set permission for users",
  manage_commissions_description: "Set commission rates of users",
  need_help: "Need help?",
  contact_us: "Contact us",
  appointment_settings: "Appointment settings",
  create_new_template: "Create new template",
  new_template_description: "Create and customize your template",
  new_template_subdescription: "Fill in the information below and start creating",
  edit_template_description: "Edit your template",
  edit_template_subdescription: "Edit your information below and save your changes",
  template_setup: "Template setup",
  template_name: "Template name",
  template_name_placeholder: "Enter template name",
  template_description: "Template description",
  template_description_placeholder: "Enter description",
  template_category: "Template category",
  medical_records_description: "Referral letter, time slip, memo",
  invoice_description: "Templates for invoices",
  receipt_description: "Templates for receipts",
  header_description: "Setup your header with logo, clinic name, address and telephone number.",
  logo: "Logo",
  clinic_name: "Clinic name",
  clinic_phone: "Clinic phone",
  tel_number: "Tel number",
  set_header_now: "Set header now",
  edit_header_now: "Edit header now",
  clinic_name_placeholder: "Enter clinic name",
  clinic_phone_placeholder: "Enter phone number",
  compose_content: "Compose content",
  insert_smart_fields: "Insert smart fields",
  smart_fields_description: "This fields allow system to automatically insert existing data. No manual editing needed",
  patient_name: "Patient name",
  doctor_name: "Doctor name",
  visit_date: "Visit date",
  identification: "Identification",
  footer_description: "Upload photo as your footer. Enable this if you want image footer in your template. Eg: Logo, company info, contact details",
  click_to_upload: "Click to upload",
  or_drag_and_drop: "or drag and drop",
  photo_upload_limitation: "JPG and PNG (max. 4MB)",
  pricing: "Pricing",
  pricing_description: "Set price and pricing tier for this template. You can manage your pricing tier in settings.",
  go_to_pricing_tier_settings: "Go to pricing tier settings",
  delete_template: "Delete template",
  template_preview: "Template preview",
  compose_content_description_item: "You can configure the properties that you want to showcase in your {item}",
  queue_system_settings: "Queue System Settings",
  queue_system_config: "Configuration",
  queue_system_config_description: "Setup your queue system preference",
  clear_queue: "Clear queue",
  clear_queue_description: "At what time you want to clear your queue?",
  qtv_preview: "QTV Preview",
  automatic_payments: "Automatic payments",
  manual_payments: "Manual payments",
  whatsapp_button: "WhatsApp button",
  whatsapp_button_description: "Let customer to send you WhatsApp message from the appointment page.",
  enable_whatsapp_button: "Enable WhatsApp button",
  clear_queue_checkbox_description: "I don't want to clear my queue automatically",
  call_your_patient_by: "Call your patient by",
  number: "Number",
  custom_numbering_group: "Custom numbering group",
  custom_numbering_group_description: "Differentiate between different type of patients.",
  room_setup: "Room setup",
  room_setup_description: "Setup your room in your queue system",
  queue_display: "Queue display",
  queue_display_description: "Configure your queue display",
  media_type: "Media type",
  video: "Video",
  language: "Language",
  scrolling_text: "Scrolling text",
  scrolling_text_description: "This text will slide in your QTV in loop",
  company_logo_preferred_dimension: "Preferred dimension: Aspect ratio of 16:9",
  change_theme_color: "Change theme color",
  rooms: "Rooms",
  equipments: "Equipments",
  room_equipment: "room / equipment",
  resource_detail: "Resource detail",
  limit_time_availability: "Limit time availability",
  limit_time_availability_description: "Turn this on to set availability schedule for this room or equipment. This is useful for limited resources, eg: X-Ray machine",
  facility_services_description: "Attach services to this room or equipment. You can create and manage your services in",
  optional: "Optional",
  type: "Type",
  add_room_or_equipment: "Add room or equipment",
  select_type: "Select type",
  record_new_tax_rate: "Record a new tax rate",
  clinic_email: "Clinic email",
  clinic_email_placeholder: "Enter email",
  add_tax: "Add tax",
  save_and_close: "Save & close",
  set_appointment: "Set appointment",
  set_appointment_description: "Please fill up the appointment details",
  new_appointment_made: "New appointment made",
  new_appointment_made_description: "This appointment is now available in your appointment page. To cancel this action, click",
  undo: "Undo",
  log_out: "Log out",
  account_settings: "Account settings",
  explore_features: "Explore features",
  upload_file: "Upload file",
  files: "Files",
  document_name: "Document name",
  enter_description: "Enter description",
  file_details: "File details",
  size: "Size",
  file_type: "File type",
  uploaded_by: "Uploaded by",
  no_document_selected: "No document selected",
  no_document_selected_description: "Select document on the left pane or start adding new medical document.",
  edit_file: "Edit file",
  file: "File",
  alignment: "Alignment",
  align_item: "Alignment {item}",
  left: "left",
  center: "center",
  right: "right",
  document_preview: "Document preview",
  editor: "Editor",
  complete_later: "Complete later",
  complete_document: "Complete document",
  unsaved_document_title: "You have unsaved changes",
  unsaved_document_description: "You have made updates in this document. Do you wish to save or discard them?",
  quit_and_discard: "Quit and discard",
  save_and_quit: "Save and quit",
  complete: "Complete",
  incomplete_document_title: "You have incomplete document",
  incomplete_document_description: "You still have incomplete documents in your treatment plan. Are you sure you want to procced?",
  ignore_and_proceed: "Ignore and proceed",
  continue_editing: "Continue editing",
  drug_label: "Drug label",
  drug_label_settings: "Drug label settings",
  drug_label_description: "Configure your drug label properties",
  properties: "Properties",
  required_by_system: "Required by system",
  drug_label_preview: "Drug label preview",
  edit_tax: "Edit tax",
  download_item_description: "You have more than one invoice templates. Confirm which template that you would like to download",
  item_templates: "{item} templates",
  print_receipt: "Print receipt",
  add_room: "Add room",
  choose_room: "Choose room",
  select_room: "Select room",
  display_name: "Display name",
  enter_display_name: "Enter display name",
  edit_room: "Edit room",
  automation: "Automation",
  primary: "Primary",
  thermal_printers: "Thermal printers",
  thermal_printers_description: "Setup your receipt printer according to your preference",
  edit_printer: "Edit printer",
  delete_printer: "Delete printer",
  select_printer: "Select only one printer below",
  searching_printers: "Searching printers",
  searching_printers_info: "Make sure you have installed desktop apps and local printer in your computer",
  paper_width: "Paper width",
  paper_height: "Paper height",
  paper_size_unit: "Paper size unit",
  printer: "Printer",
  hostname: "Hostname",
  cost: "Cost",
  price_to_patient: "Price to patient",
  group: "Group",
  cost_price: "Cost price",
  insight: "Insight",
  patient_database: "Patient database",
  patient_profile: "Patient profile",
  visits: "Visits",
  view_visit_summary: "View visit summary",
  total_spend: "Total spend",
  total_visit: "Total visit",
  since: "Since",
  due: "Due",
  visit_summary: "Visit summary",
  edit_diagnosis: "Edit diagnosis",
  amount_to_claim: "Amount to claim",
  select_diagnosis: "Select diagnosis",
  no_result_match: "No results match",
  medical_certificate_description: "Template for medical certificate",
  medical_certificate_instruction: "Fill out information below to complete document",
  no_of_days: "No of days",
  created_date: "Created date",
  medicine_reports: "Medicine reports",
  medicine_reports_description: "Download medicine reports",
  sales_reports: "Sales reports",
  closing_reports: "Closing reports",
  sales_reports_description: "Download sales reports",
  closing_reports_description: "Download closing reports",
  unpaid_balance: "Unpaid balance",
  seller: "Seller",
  invoice_no: "Invoice number",
  opt_in_booking: "Opt-in booking",
  opt_in_booking_description: "Set whether you would like to accept booking automatically or manually",
  approve_booking_auto: "Do you want to approve booking automatically?",
  yes_approve: "Yes, I would like to approve the service’s booking automatically.",
  yes_approve_description: "Bookings for this service will be approved automatically.",
  no_approve: "No, every new bookings will need to be approved.",
  no_approve_description: "Booking requests will be added to your dashboard. ",
  booking_details: "Booking details",
  edit_booking_details: "Edit booking details",
  inventory_services_packages: "Inventory, Services & Packages",
  manage_inventory_services_packages_description: "Manage your practice item, services & packages",
  birthday: "Birthday",
  staffid: "Staff ID",
  marketing: "Marketing",
  first_purchase: "First purchase",
  first_purchase_subtitle: "This automated message preset is to be sent to customers who visit your premise for the first time.",
  first_purchase_content_description: "Special offers to welcome new customers making their first purchase.",
  second_purchase: "Second purchase",
  second_purchase_subtitle: "This automated message preset is to be sent to customers who made purchase in your premise for the second time.",
  second_purchase_content_description: "Special offers to welcome customers back for their second visit.",
  birthday_subtitle: "This automated message preset is to be sent to customers who are celebrating their birthday",
  birthday_content_description: "Special offers sent to customers on their birthday.",
  reactivation: "Reactivation",
  reactivation_subtitle: "This automated message preset is to be sent to customers who has not visited your premise for more than 60 days",
  reactivation_content_description: "Special offers to bring back customers who haven't visited in a while.",
  rates: "Rates",
  choose_your_reload_amount: "Choose your reload amount",
  visit_frequency: "Visit frequency",
  activity: "Activity",
  not_visited_for: "Not visited for",
  visited_last: "Visited last",
  available: "Available",
  equals_to: "Equals to",
  between: "Between",
  insert_value: "Insert value",
  last_stamps_before_reward: "Last stamps before reward",
  date_of_birth: "Date of birth",
  whatsapp_review_message_template_description: "Write a custom automated message to be sent when requesting review via WhatsApp",
  bookings: "Bookings",
  reset_filters: "Setel ulang filter",
  na: "T/A",
  enter: "Masukkan",
  email_must_be_valid: "Email harus valid",
  // Global panel-related translations
  admin_fee: "Biaya admin",
  admin_fee_cannot_be_negative: "Biaya admin tidak boleh negatif",
  percentage_must_be_between_0_and_100: "Persentase harus antara 0 dan 100",
  percentage_must_be_integer: "Persentase harus berupa bilangan bulat",
  rejected_amount_cannot_be_negative: "Jumlah yang ditolak tidak boleh negatif",
  days_cannot_be_negative: "Hari tidak boleh negatif",
  days_must_be_integer: "Hari harus berupa bilangan bulat",
  panel: {
    panel: "Panel",
    claim: "Klaim",
    claims: "Klaim",
    add_panel: "Tambah panel",
    panel_information: "Informasi panel",
    contact_information: "Informasi kontak",
    fill_panel_info_below: "Isi informasi panel di bawah ini.",
    panel_type: "Jenis panel",
    third_party_administrator: "Administrator Pihak Ketiga",
    direct_company: "Perusahaan langsung",
    submission_delivery_preference: "Preferensi pengiriman klaim",
    set_how_claims_delivered: "Atur bagaimana klaim dikirim ke panel yang dipilih.",
    single_claim: "Klaim tunggal",
    bulk_claim: "Klaim massal",
    company_registration_number: "Nomor registrasi perusahaan",
    company_registration_number_description: "12-digit SSM ID diperlukan",
    company_name: "Nama perusahaan",
    panel_name: "Nama panel",
    panel_code: "Kode panel",
    person_in_charge: "Penanggung jawab",
    panel_verification: "Verifikasi panel",
    provide_link_for_users: "Berikan tautan untuk pengguna meninjau informasi panel.",
    url_to_panel_platform: "URL ke platform panel",
    manual_remark: "Catatan manual",
    verification_link: "Tautan verifikasi",
    panel_rule: "Aturan panel",
    set_operational_terms: "Tetapkan ketentuan operasional untuk panel ini.",
    claim_submission_due_date: "Tanggal jatuh tempo pengajuan klaim",
    fixed_deadline: "Batas waktu tetap",
    relative_deadline: "Batas waktu relatif",
    by: "pada",
    select_price_tier: "Pilih tingkat harga",
    manage_pricing_tier: "Kelola tingkat harga Anda di pengaturan.",
    pricing_tier_setting: "Pengaturan tingkat harga",
    price_tier: "Tingkat harga",
    e_invoice_setting: "Pengaturan e-invoice",
    e_invoice_setting_description: "TIN ini akan digunakan untuk pengajuan e-invoice klaim panel.",
    income_tax_number_tin: "Nomor Pokok Wajib Pajak (TIN)",
    panel_added_successfully: "Panel berhasil ditambahkan",
    please_enter_valid_url: "Silakan masukkan URL verifikasi yang valid",
    panel_name_tooltip: "Nama yang lebih pendek (mis. AIA, Prudential, dll.) yang akan ditampilkan dalam daftar pilihan.",
    remarks: "Catatan",
    after_invoice_finalised: "setelah invoice diselesaikan",
    visits: "Kunjungan",
    visits_description: "Di bawah ini adalah daftar kunjungan karyawan panel ke klinik ini.",
    no_visits_found: "Tidak ada kunjungan ditemukan",
    view_invoice: "Lihat invoice",
    view_claim: "Lihat klaim",
    create_claim: "Buat klaim",
    eligible_staffs: "Staf yang memenuhi syarat",
    eligible_staffs_description: "Di bawah ini adalah daftar karyawan yang memenuhi syarat untuk klaim di bawah panel ini.",
    no_staff_found: "Tidak ada staf ditemukan",
    view_staff_details: "Lihat detail staf",
    panel_reports: "Laporan panel",
    download_panel_reports: "Unduh laporan panel",
    panel_invoices: "Faktur panel",
    download_panel_invoices: "Unduh faktur panel",
    claims_message_templates: "Template pesan klaim",
    manage_message_templates_claims: "Kelola template pesan untuk klaim",
    panel_management: "Manajemen Panel",
    claim_message_template: "Template pesan klaim",
    panel_configuration: "Konfigurasi panel",
    staff_assignments: "Penugasan staf",
    payment_integration: "Integrasi pembayaran",
    message_template: "Template pesan",
    message_template_description: "Siapkan pesan yang sudah diisi sebelumnya untuk mengirimkan klaim ke panel. Salin dan kirim langsung melalui saluran pilihan Anda.",
    single_claim_description: "Template ini akan digunakan saat mengirimkan klaim tunggal ke panel yang dipilih. Konfigurasikan konten pesan Anda sebelum mengirim.",
    bulk_claim_description: "Template ini akan digunakan saat mengirimkan beberapa klaim ke panel yang dipilih. Konfigurasikan konten pesan Anda sebelum mengirim.",
    set_now: "Atur sekarang",
    message_preview: "Pratinjau pesan",
    edit_template: "Sunting template",
    claim_message_template_setup: "Pengaturan Template Pesan Klaim",
    message_content: "Konten pesan",
    message_content_description: "Tentukan konten pesan yang akan dikirim saat mengirimkan klaim.",
    insert_smart_fields: "Masukkan smart fields",
    smart_fields_description: "Field ini memungkinkan sistem untuk secara otomatis memasukkan data yang ada.",
    billing_details: "Detail penagihan",
    who_is_this_person: "Siapa orang ini?",
    open_link: "Buka link",
    enter_staff_id: "Masukkan ID staf",
    enter_chit_number: "Masukkan nomor chit",
    patient_nric: "NRIC pasien",
    staff_id: "ID staf",
    chit_number: "Nomor chit",
    claim_number: "Nomor klaim",
    total_invoice: "Total invoice",
    claimed_amount: "Jumlah klaim",
    submission_date: "Tanggal pengajuan",
    claim_link: "Link klaim",
    mc_days: "Hari MC",
    diagnosis: "Diagnosis",
    medication: "Obat",
    clinic_name: "Nama klinik",
    panel_claims: "Klaim panel",
    claim_for: "untuk",
    submitted_on: "Diajukan pada",
    updated_by: "Diperbarui oleh",
    download_pdf: "Unduh PDF",
    send_claim: "Kirim klaim",
    edit_claim: "Edit panel klaim",
    revert_claim_to_invoice: "Kembalikan klaim ke faktur",
    download_invoice: "Unduh faktur",
    download_receipt: "Unduh tanda terima",
    download_panel_claim: "Unduh klaim panel",
    download_limit_exceeded: "Anda hanya dapat mengunduh maksimal 20 item sekaligus",
    ssm_must_be_digits: "ID SSM hanya boleh berisi angka.",
    ssm_must_be_12_characters: "ID SSM harus tepat 12 karakter.",
    stats_submissions: "Pengajuan",
    stats_pending: "Tertunda",
    stats_overdue: "Terlambat",
    stats_payouts: "Pembayaran",
    stats_approved: "Disetujui",
    stats_received: "Diterima",
    stats_rejected: "Ditolak",
    stats_outstanding: "Belum Dibayar",
    // Filter-related keys
    amount: "Jumlah",
    claim_type: "Jenis klaim",
    name: "Nama",
    doctor: "Dokter",
    visit_type: "Jenis kunjungan",
    treatment: "Perawatan",
    visit_date: "Tanggal kunjungan",
    // Comparison operators
    comparison: "Perbandingan",
    is: "Adalah",
    is_not: "Bukan",
    less_than: "Lebih kecil dari",
    more_than: "Lebih besar dari",
    is_between: "Diantara",
    greater_than: "Lebih besar dari",
    greater_than_or_equal: "Lebih besar atau sama dengan",
    less_than_or_equal: "Lebih kecil atau sama dengan",
    equal_to: "Sama dengan",
    between: "Antara",
    // Amount fields
    minimum_amount: "Jumlah minimum",
    maximum_amount: "Jumlah maksimum",
    // Date range fields
    minimum_days: "Hari minimum",
    maximum_days: "Hari maksimum",
    days: "Hari",
    // Patient name search
    patient_name: "Nama pasien",
    search_type: "Jenis pencarian",
    contains: "Mengandung",
    starts_with: "Dimulai dengan",
    does_not_contain: "Tidak mengandung",
    ends_with: "Diakhiri dengan",
    enter_patient_name: "Masukkan nama pasien",
    // Claim number
    enter_claim_number: "Masukkan nomor klaim",
    // Visit types
    consultation: "Konsultasi",
    follow_up: "Tindak lanjut",
    emergency: "Darurat",
    procedure: "Prosedur",
    vaccination: "Vaksinasi",
    health_screening: "Pemeriksaan kesehatan",
    // Date ranges
    date_range: "Rentang tanggal",
    start_date: "Tanggal mulai",
    end_date: "Tanggal akhir",
    today: "Hari ini",
    last_7_days: "7 hari terakhir",
    last_30_days: "30 hari terakhir",
    this_month: "Bulan ini",
    last_month: "Bulan lalu",
    custom_range: "Rentang kustom",
    // Date filter operators
    is_equal_to: "Sama dengan",
    is_in_the_last: "Dalam",
    is_after: "Setelah",
    is_on_or_after: "Pada atau setelah",
    is_before: "Sebelum",
    is_before_or_on: "Sebelum atau pada",
    weeks: "Minggu",
    months: "Bulan",
    years: "Tahun",
    // Claim types
    single: "Tunggal",
    bulk: "Massal",
    no_items_found: "Tidak ada item ditemukan",
    // Invoice filter
    invoice_number: "Nomor invoice",
    enter_invoice_number: "Masukkan nomor invoice",
    due_date: "Tanggal jatuh tempo",
    // Tab labels
    tab_all: "Semua",
    tab_pending: "Tertunda",
    tab_overdue: "Terlambat",
    tab_submitted: "Diajukan",
    tab_approved: "Disetujui",
    tab_rejected: "Ditolak",
    tab_received: "Diterima",
    tab_cancelled: "Dibatalkan",
    tab_visits: "Kunjungan",
    tab_eligible_staffs: "Staf yang memenuhi syarat",
    // Status labels
    status_submitted: "Diajukan",
    status_approved: "Disetujui",
    status_rejected: "Ditolak",
    status_received: "Diterima",
    status_pending: "Tertunda",
    status_overdue: "Terlambat",
    status_cancelled: "Dibatalkan",
    // Dialog titles
    send_panel_claim: "Kirim klaim panel",
    panel_claim_details: "Detail klaim panel",
    invoice_details: "Detail faktur",
    selected_invoices: "Faktur yang dipilih",
    edit_bulk_panel_claim: "Edit klaim panel massal",
    create_bulk_panel_claim: "Buat klaim panel massal",
    edit_panel_claim: "Edit klaim panel",
    create_panel_claim: "Buat klaim panel",
    documents: "Dokumen",
    payments: "Pembayaran",
    file_details: "Detail file",
    add_payment: "Tambah pembayaran",
    edit_payment: "Edit pembayaran",
    // Field labels
    panel_details: "Detail panel",
    patient_details: "Detail pasien",
    treatment_items: "Item perawatan",
    invoice_no: "No. faktur",
    staff_details: "Detail staf",
    treatments: "Perawatan",
    total: "Total",
    claim_status: "Status klaim",
    record_deductions: "Catat potongan:",
    upload_photo: "Unggah foto",
    add_from_other_devices: "Tambahkan dari perangkat lain",
    payment_method: "Metode pembayaran",
    payment_reference_no: "No. referensi pembayaran",
    payment_type: "Jenis pembayaran",
    payment_notes: "Catatan pembayaran (opsional)",
    approved_amount: "Jumlah disetujui",
    rejected_amount: "Jumlah ditolak",
    total_received: "Total diterima",
    amount_due: "Jumlah jatuh tempo",
    document_name: "Nama dokumen",
    type: "Jenis",
    size: "Ukuran",
    date: "Tanggal",
    uploaded_by: "Diunggah oleh",
    received_amount: "Jumlah diterima",
    payment_notes_label: "Catatan pembayaran",
    approved_date: "Tanggal disetujui",
    item_name: "Nama item",
    rate: "Harga",
    qty: "Jumlah",
    staff_id_field: "ID Staf",
    chit_no: "No. chit",
    visit: "Kunjungan",
    nric: "NRIC",
    phone_number: "Nomor telepon",
    email: "Email",
    visit_note: "Catatan kunjungan",
    file_type: "Jenis file",
    created: "Dibuat",
    upload_date: "Tanggal unggah",
    submitted_date: "Tanggal diajukan",
    submitted_date_label: "Tanggal diajukan",
    submitted_amount: "Jumlah diajukan",
    approved_date_label: "Tanggal disetujui",
    approved_amount_label: "Jumlah disetujui",
    rejected_date_label: "Tanggal ditolak",
    rejected_amount_label: "Jumlah ditolak",
    received_date_label: "Tanggal diterima",
    received_amount_label: "Jumlah diterima",
    // Actions
    copy_message: "Salin pesan",
    done: "Selesai",
    add_document: "Tambah dokumen",
    unselect_all: "Batalkan pilihan semua",
    online_banking: "Online banking",
    cheque: "Cek",
    full_payment: "Pembayaran penuh",
    partial_payment: "Pembayaran sebagian",
    switch_to_list: "Beralih ke daftar",
    switch_to_thumbnail: "Beralih ke thumbnail",
    upload_new: "Unggah baru",
    // Messages
    panel_claim_created_successfully: "Klaim panel berhasil dibuat. Kirim klaim panel sekarang?",
    copy_message_instruction: "Salin pesan di bawah ini dan tempelkan ke email atau WhatsApp Anda untuk memberi tahu panel.",
    scan_qr_instruction: "Pindai kode QR ini untuk mengunggah foto dari perangkat lain Anda (Mis: ponsel, tablet)",
    message_copied: "Pesan disalin ke clipboard",
    failed_copy_message: "Gagal menyalin pesan",
    text_copied: "Teks disalin ke clipboard",
    failed_copy_text: "Gagal menyalin teks",
    link_copied: "Tautan disalin ke clipboard",
    failed_copy_link: "Gagal menyalin tautan",
    unable_to_generate_link: "Tidak dapat membuat tautan",
    documents_added: "Dokumen berhasil ditambahkan",
    failed_add_documents: "Gagal menambahkan dokumen. Silakan coba lagi.",
    upload_at_least_one_document: "Silakan unggah setidaknya satu dokumen",
    qr_code_error: "Kesalahan pada kode QR. Silakan coba lagi nanti.",
    syncing_files_error: "Kesalahan saat menyinkronkan file. Silakan coba lagi nanti.",
    document_deleted: "Dokumen berhasil dihapus",
    failed_delete_document: "Gagal menghapus dokumen. Silakan coba lagi.",
    payment_deleted: "Pembayaran berhasil dihapus.",
    failed_delete_payment: "Gagal menghapus pembayaran. Silakan coba lagi.",
    invalid_payment_data: "Data pembayaran tidak valid.",
    claim_created: "Klaim berhasil dibuat",
    failed_create_claim: "Gagal membuat klaim. Silakan coba lagi.",
    claim_updated: "Klaim berhasil diperbarui",
    failed_update_claim: "Gagal memperbarui klaim. Silakan coba lagi.",
    fill_required_fields: "Silakan isi semua bidang yang diperlukan dengan benar.",
    bulk_claim_created: "Klaim massal berhasil dibuat",
    failed_create_bulk_claim: "Gagal membuat klaim massal. Silakan coba lagi.",
    bulk_claim_updated: "Klaim massal berhasil diperbarui",
    failed_update_bulk_claim: "Gagal memperbarui klaim. Silakan coba lagi.",
    panel_info_missing: "Informasi panel hilang. Silakan coba lagi.",
    no_invoices_found: "Tidak ada faktur ditemukan untuk item yang dipilih. Silakan periksa dan coba lagi.",
    copy_successful: "Salin berhasil",
    payment_added: "Pembayaran berhasil ditambahkan.",
    payment_updated: "Pembayaran berhasil diperbarui.",
    failed_save_payment: "Gagal menyimpan pembayaran. Silakan coba lagi.",
    fill_required_fields_payment: "Silakan isi bidang yang diperlukan.",
    amount_greater_than_zero: "Jumlah harus lebih besar dari nol",
    filter_parameters_corrupted: "Parameter filter rusak. Filter telah dihapus.",
    // Placeholders
    enter_amount: "Masukkan jumlah",
    payment_ref_placeholder: "FPX1234567890",
    write_payment_note_here: "Tulis catatan pembayaran di sini",
    write_remarks_here: "Tulis catatan di sini",
    select_submitted_date: "Pilih tanggal diajukan",
    select_approved_date: "Pilih tanggal disetujui",
    select_rejected_date: "Pilih tanggal ditolak",
    select_received_date: "Pilih tanggal diterima",
    select_price_tiers: "Pilih tingkat harga",
    click_to_upload: "Klik untuk mengunggah",
    or_drag_and_drop: "atau seret dan lepas",
    jpg_png_max_5mb: "JPG dan PNG (maks. 5MB)",
    // Descriptions
    invoice_details_description: "Di bawah ini adalah detail faktur yang dipilih.",
    selected_invoices_description: "Tinjau faktur yang termasuk dalam klaim panel ini sebelum melanjutkan.",
    panel_claim_details_description: "Informasi penting terkait klaim panel yang diajukan.",
    review_invoices_before_proceeding: "Tinjau faktur yang termasuk dalam klaim panel ini sebelum melanjutkan.",
    review_invoices_bulk_claim: "Tinjau faktur yang termasuk dalam klaim massal ini.",
    key_information_submitted_claim: "Informasi penting yang akan diajukan dengan klaim ini.",
    scan_qr_upload_description: "Pindai kode QR untuk mengunggah file dari perangkat lain.",
    // Badges and status
    panel_badge: "Panel",
    multiple_patients: "Beberapa pasien",
    multiple_panels: "Beberapa Panel",
    // Empty states
    no_document_added: "Tidak ada dokumen ditambahkan",
    added_document_will_show_here: "Dokumen yang ditambahkan akan ditampilkan di sini",
    no_payment_added: "Tidak ada pembayaran ditambahkan",
    added_payment_will_show_here: "Pembayaran yang ditambahkan akan ditampilkan di sini",
    no_document_selected: "Tidak ada dokumen dipilih",
    select_files_left_pane: "Pilih file di panel kiri untuk melihat detail",
    preview_not_available: "Pratinjau tidak tersedia",
    no_eligible_staff_found: "Tidak ada staf yang memenuhi syarat ditemukan",
    eligible_staff_will_appear_here: "Anggota staf yang memenuhi syarat untuk panel ini akan muncul di sini",
    no_visits_recorded: "Tidak ada kunjungan tercatat",
    visits_will_appear_here: "Setiap kunjungan panel masa lalu dan saat ini akan muncul di sini",
    no_treatment_items_found: "Tidak ada item perawatan ditemukan",
    unable_to_load_claim_details: "Tidak dapat memuat detail klaim",
    check_claim_rid_and_retry: "Informasi klaim tidak dapat diambil. Silakan periksa RID klaim dan coba lagi.",
    unable_to_load_invoices: "Tidak dapat memuat faktur",
    check_and_retry: "Informasi faktur tidak dapat diambil. Silakan periksa dan coba lagi.",
    unable_to_load_invoice_details: "Tidak dapat memuat detail faktur",
    check_invoice_id_and_retry: "Informasi faktur tidak dapat diambil. Silakan periksa ID faktur dan coba lagi.",
    invoice_info_could_not_be_retrieved: "Informasi faktur tidak dapat diambil. Silakan coba lagi.",
    // Date ranges
    all_time: "Sepanjang waktu",
    yesterday: "Kemarin",
    last_90_days: "90 hari terakhir",
    this_week: "Minggu ini",
    this_year: "Tahun ini",
    last_week: "Minggu lalu",
    custom: "Kustom",
    // Other
    files: "file",
    invoice: "faktur",
    invoices: "faktur",
    items: "item",
    loading_pdf: "Memuat PDF...",
    selected: "Dipilih",
    submit: "Kirim",
    submit_daily: "Kirim setiap hari pada",
    submit_weekly: "Kirim setiap minggu pada",
    submit_monthly: "Kirim setiap bulan pada",
    same_day: "Hari yang sama",
    next_day: "Hari berikutnya",
    days_after_2: "2 hari setelah",
    days_after_3: "3 hari setelah",
    payment_details: "Detail Pembayaran:",
    method: "Metode:",
    notes: "Catatan:",
    reference_no: "No. Referensi:",
    // Validation
    payment_method_required: "Metode pembayaran wajib diisi",
    amount_required: "Jumlah wajib diisi",
    payment_type_required: "Jenis pembayaran wajib diisi",
    date_required: "Tanggal wajib diisi",
    please_select_at_least_one_price_tier: "Silakan pilih setidaknya satu tingkat harga",
    // Actions and UI elements
    view: "Lihat",
    logs: "Log",
    add_note: "Tambah catatan",
    add_more: "Tambah lagi",
    // Error states
    unable_to_load_logs: "Tidak dapat memuat log",
    log_info_could_not_be_retrieved: "Informasi log tidak dapat diambil. Silakan coba lagi.",
    try_again: "Coba lagi",
    // Success messages
    note_deleted_successfully: "Catatan berhasil dihapus",
    download_started: "Unduhan dimulai",
    // Additional UI translations
    payment_summary: "Ringkasan pembayaran",
    assigned: "Ditugaskan",
    assign_balance: "Tetapkan saldo",
    select_at_least_2_invoices: "Pilih setidaknya 2 faktur",
    all_invoices_same_panel: "Semua faktur yang dipilih harus dari panel yang sama",
    update_claim_status: "Perbarui status klaim panel",
    mark_all_as_approved: "Tandai semua sebagai disetujui",
    mark_all_as_rejected: "Tandai semua sebagai ditolak",
    mark_all_as_received: "Tandai semua sebagai diterima",
    changing_to_single_view: "Mengubah ke tampilan klaim panel tunggal",
    please_wait_updating_view: "Harap tunggu sementara kami memperbarui tampilan...",
    staff_identification_list: "Daftar identifikasi staf",
    staff_identification_description: "Catat nomor identifikasi staf pasien saat pendaftaran.",
    panel_required: "Panel wajib diisi",
    staff_id_required: "ID Staf wajib diisi",
    select_panel: "Pilih panel",
    please_select_panel: "Silakan pilih panel",
    // Single claim summary card (only non-duplicate keys)
    summary: "Ringkasan",
    billed_to: "Ditagih kepada",
    panel_claim_number: "Nomor klaim panel",
    id: "ID",
    panel_claim_submission_due_date: "Tanggal jatuh tempo pengajuan klaim panel",
    received_date: "Tanggal diterima",
    invoice_items: "Item invoice",
    invoice_total: "Total invoice",
    no_claim_associated: "Tidak ada klaim yang terkait",
    created_date: "Tanggal dibuat",
    select_date: "Pilih tanggal",
  },
  registration_form: {
    self: "Mandiri",
    dependent: "Tanggungan",
  },
  registration_page: {
    cancel_visit: {
      title: "Konfirmasi pembatalan kunjungan",
      warning_message: "Membatalkan kunjungan ini juga akan membatalkan faktur dan klaim yang terkait.",
      subtitle: "Tindakan ini akan dilakukan segera dan tidak dapat dibatalkan. Klik \"Konfirmasi\" untuk melanjutkan.",
      linked_documents: "Dokumen terkait:",
      invoice_number: "Nomor faktur",
      panel_claim_number: "Nomor klaim panel",
      claim: "Klaim detail",
      claim_amount: "Jumlah klaim",
      current_claimed_amount: "Jumlah klaim saat ini",
      new_claim_amount: "Jumlah klaim baru",
      total_adjustments: "Total penyesuaian",
      visit_cancelled_successfully: "Kunjungan berhasil dibatalkan",
      restriction_title: "Pembatasan pembatalan kunjungan",
      restriction_not_allowed: "Pembatalan kunjungan ini tidak diizinkan.",
      restriction_approved_received: "Pembatalan kunjungan dibatasi karena faktur terkait dengan klaim berstatus {status}.",
      restriction_multiple_claims: "Pembatalan kunjungan dibatasi karena faktur terkait dengan beberapa klaim.",
      close: "Tutup"
    }
  }
}